import react, { Dispatch, SetStateAction, useEffect, useMemo, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { botProductPageChat, getVerifyOTP, getBotConfigurations, memoryClear, getRecommendationsStyleIdeas, bundlingSuggestion, getAnswer, getHandler, user_story_bundling_api, login, getVerifiedEmail, getUserValidation } from '../services/chatBotService';
import { useDispatch } from 'react-redux';
import { useSelector } from "react-redux";
// import { RootState } from "redux/store";
import _, { chunk, result } from "lodash";
import { toast } from "react-toastify";
import { CloseEyeIcon, chatBotRefresh, eyeIcon, searchSend, LinkIcon, LinkIconWhite, StarFill, StarEmplty, cancelIcon, ProductAdd, CloseIcon, ChooseIcon, searchMicActive, searchMic, shopMateIcon, DeleteRed, leftIcon, rightIcon, speakerIcon } from "../assets/icons/index";
import defaultImg from "../assets/images/default-img.png";
import { controlHandlerState, handleBotLoginQue, handleIsUserHandler } from "../redux/persistentSlice";
import ReactMarkdown from 'react-markdown';
import styles from '../assets/styles/ai-chat-bot/markdownRenderer.module.css';
import CryptoJS from 'crypto-js';
import * as myconst from "../constants/index"
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import { Carousel, CarouselResponsiveOption } from "primereact/carousel";
import { Checkbox } from "primereact/checkbox";
// import VoiceSearch from "components/VoiceSearch";
import React from "react";
import Cookies from 'js-cookie';
import { Badge } from "primereact/badge";
// import remarkGfm from 'remark-gfm';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { addQuestion, resetQuestion, setSuggestionList, updateQuestion, handBotleLoader, addProductPageQuestion, updateProductPageQuestion, resetProductPageQuestion, setUserHandlerName, setIsNewConversation, addOrRemoveObjectForAddToCart, handleAnswerCalling, addMessages, setStopId, setShowSidePanel } from "../redux/counterSlice";
import { AppDispatch } from "../redux/store";
import { decryptAesGcmB64, encryptJsonAesGcmB64 } from "../utils/crypto";
import VoiceSearch from "./VoiceSearch";
import { ChartWrapper } from "./ChartWrapper";
import DynamicTable from "./DynamicTable";
import { Accordion, AccordionTab } from "primereact/accordion";
import { createConversation } from "../services/chatService";
interface ChartObject {
	test: string;
	setTest: any;
	errored: boolean;
	setError: Dispatch<SetStateAction<boolean>>;
	typePassword: boolean;
	setTypePassword: any
	followUP: boolean;
	setFollowUP: Dispatch<SetStateAction<boolean>>;
	conversation_id: any;
	chatTitle: string;
	setChatTitle: Dispatch<SetStateAction<string>>;
	fetchChatSessions: ()=>void;
}

interface QueryObject {
	Question: string;
	SQLQuery: string;
	Ans: string;
}

type BotConfigurationResponse = {
	bot_name: string | null,
	organization_info: {
		organization_name: string,
		organization_url: string,
		domain_name: string,
		description: string
	},
	bot_config: {
		bot_name: string,
		tagline: string,
		initial_message: string,
		bot_logo: string,
		bot_logo_name: string,
		avtar_logo_name: string,
		avatar_logo: string,
		header_colour: string,
		question_background_colour: string,
		answer_background_colour: string,
		font_type: string,
		font_size: number
	},
	db_credentials_info: {
		csv_data: string,
		csv_name: string,
		host: string,
		port: number,
		user_name: string,
		password: string,
		db_name: string,
		tables: string[]
	},
	question_answer_info: {
		Question_Answer: QueryObject[],
	},
	config_info_change: {
		temperature: number,
		max_token: number
	},
	spipeet_info: {
		snipeet_code: string
	},
	is_config_info: boolean,
	is_question_answer: boolean,
	is_file: boolean,
	created_by: string
}

interface Product {
	variant_id: string;
	sku: string,
	title: string,
	variant_image: string,
	price: number,
	Description: string,
	category: string,
	subcategory?: string,
	brand?: string,
	rating?: number,
	no_of_rating?: number,
	no_of_reviews?: number,
	color: string,
	gender?: string,
	size?: string
}
interface ProductTemplateProps {
	product: Product;
	products: Product[];
}

const ImageWithFallback = ({ src, alt, styles, fallbackSrc }: { src: string, alt: string, styles?: any, fallbackSrc: any }) => {
	const [imageSrc, setImageSrc] = useState(src);
	const [hasErroredOnce, setHasErroredOnce] = useState(false);
	useEffect(() => {
		if (!src) return;

		const img = new Image();
		img.src = src;

		img.onload = () => {
			setImageSrc(src); // Only set if it successfully loads
		};

		img.onerror = () => {
			setImageSrc(fallbackSrc); // Fall back if it fails to load
		};
	}, [src, fallbackSrc]);


	const handleError = () => {
		// setImageSrc(defaultImg);
		if (!hasErroredOnce) {
			setHasErroredOnce(true);
			setImageSrc(fallbackSrc); // Try default image if main fails
		}
	};
	return (
		<img
			src={imageSrc}
			alt={alt}
			onError={handleError}
			style={styles}
		/>
	);
};

const Chatbot = ({ test, setTest, errored, setError, followUP, setFollowUP, typePassword, setTypePassword, conversation_id, chatTitle, setChatTitle, fetchChatSessions }: ChartObject) => {
	const dispatch = useDispatch<AppDispatch>();
	const scrollRef = useRef<HTMLDivElement>(null);
	const botLoader = useSelector((state: any) => state.counter.botLoader);
	const isAnswerCalling = useSelector((state: any) => state.counter.isAnswerCalling);
	const stopId = useSelector((state: any) => state.counter.stopId);
	const userHandlerName = useSelector((state: any) => state.counter.userHandlerName);
	const isNewConversation = useSelector((state: any) => state.counter.isNewConversation);
	const addToCartObj = useSelector((state: any) => state.counter.addToCartObj);
	const handlerState = useSelector((state: any) => state.persistent.handlerState);
	const isUserHandler = useSelector((state: any) => state.persistent.isUserHandler);
	const addToCartProducts = localStorage.getItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`);
	const ishandleModeDetails = useSelector((state: any) => state.persistent.handleMode);
	// const addToCartProducts = Cookies.get(`addToCartProducts${localStorage.getItem('username')}`);
	const addToCartProductsParse = addToCartProducts !== undefined && addToCartProducts !== null ? JSON.parse(addToCartProducts as any) : [];
	const [cartpageVisible, setCartPageVisible] = useState<boolean>(false);
	const [productList, setProductList] = useState<any>([])
	const [productCartList, setProductCartList] = useState<any>([])
	const [singleProduct, setSingleProduct] = useState<any>([])
	const [cartProducts, setCartsProduct] = useState<any>(addToCartProductsParse);
	const [productCompareList, setProductCompareList] = useState<any>([])
	const [showSuggestions, setShowSuggestions] = useState(false);
	const [styledIdeaProducts, setStyledIdeaProducts] = useState<any>([])
	const [bundlingSuggestionProducts, setBundlingSuggestionProducts] = useState<any>([])
	const [botProduct, setBotProduct] = useState("");
	const [showLeft, setShowLeft] = useState(false);
	const [showRight, setShowRight] = useState(false);
	// const [activeProduct, setActiveProduct] = useState("");
	const [linkIconsHover1, setLinkIconHover1] = useState(LinkIcon)
	const [linkIconsHover2, setLinkIconHover2] = useState(LinkIcon)
	const messagesEndRef = useRef<HTMLInputElement>(null);
	const messages = useSelector((state: any) => state.counter.messages);
	const suggestionList = useSelector((state: any) => state.counter.suggestionList);
	const productPageMessages = useSelector((state: any) => state.counter.productPageMessages)
	const botLoginQue = useSelector((state: any) => state.persistent.botLoginQue);
	// const botProduct = useSelector((state: any) => state.counter.botProduct);
	const token = localStorage.getItem("chat_access_token");
	const username = localStorage.getItem("username");
	const [message, setMessage] = useState<string>("");
	const [currentActivePage, setCurrentActivePage] = useState<string>("detail");
	const [showPassword, setShowPassword] = useState(false);
	const [toggleAddProducts, setToggleAddProducts] = useState<boolean>(false);
	// const [test, setTest] = useState<string>("");
	const [sendOtp, setSendOtp] = useState<string>("");
	const [chatToken, setChatToken] = useState(token ? token : "");
	const [chatName, setChatName] = useState(username ? username : "");
	const [data, setData] = useState<BotConfigurationResponse>();
	const [customer, setCustomer] = useState<any>(null);
	const [botl, setBotl] = useState<any>("");
	const [avtarl, setAvtarl] = useState<any>("");
	const [addedCompare, setAddedCompare] = useState<string>("");
	const [addToCart, setAddToCart] = useState<string>("");
	const [addToCartBtnName, setAddToCartBtnName] = useState<string>("Add to Cart");
	const [fontSize1, setFontSize1] = useState<any>();
	const [activeIndex, setActiveIndex] = useState<number>(0);
	const [activeIndexStyledProduct, setActiveIndexStyledProduct] = useState<number>(0);
	const [activeIndexBundleProduct, setActiveIndexBundleProduct] = useState<number>(0);
	const inputRef: any = useRef(null);
	const productPageChatRef: any = useRef(null);
	const productDetailPageRef: any = useRef(null);
	const currentAudioRef = useRef<HTMLAudioElement | null>(null);
	// Tracks the latest TTS request so older ones are ignored
	const ttsRequestIdRef = useRef(0);
	const [lastProductId, setLastProductId] = useState<any>(null);
	const [isKeyDown, setIsKeyDown] = useState(false);
	const [isTTSLoading, setIsTTSLoading] = useState<boolean>(false);
	// Track TTS status per message id: 'idle' | 'preparing' | 'playing'
	const [ttsStatusById, setTtsStatusById] = useState<Record<string, 'idle' | 'preparing' | 'playing'>>({});
	const inputbox: any = document.querySelector('.input-box');
	const sendButton: any = document.querySelector('#send-button');
	const KEY_B64 = "wS/Fpl50yt7d1jHkz08RuEltjTxGJ6lt/7A0DhL3g0w="
	let chunkedStyledIdeaProducts = styledIdeaProducts?.length > 3 ? chunk(styledIdeaProducts, 3) : [styledIdeaProducts];
	const voiceSearch = VoiceSearch(
		setIsKeyDown,
		inputbox,
		sendButton,
		setMessage,
		'mainchat'
	);
	const isAuthDetails = useSelector((state: any) => state.persistent.isAuth);
	const handleStartListening = voiceSearch.handleStartListening;
	const yesSynonyms = ["yes", "yep", "yup", "yeah", "sure", "uh-huh", "definitely", "totally", "you bet", "without a doubt", "aye", "fo sho", "yepper", "alright", "okay", "fine", "agrred", "absolutely", "certainly", "indeed", "of course", "affirmative"]
	const noSynonyms = ["no", "not", "certainly not", "by no means", "not at all", "negative", "i'am afraid not", "nope", "nah", "no way", "uh-uh", "never", "don't", "nah-ah", "nada"]

	const responsiveOptions: CarouselResponsiveOption[] = [
		{
			breakpoint: '479px',
			numVisible: 2,
			numScroll: 1
		},
		{
			breakpoint: '380px',
			numVisible: 1,
			numScroll: 1
		}
	];
	const handleChange = (e: any) => {
		if (!showPassword && typePassword) {
			setMessage(e.target.value.trim());
		} else {
			setMessage(e.target.value);
			dispatch(setShowSidePanel(false));
		}
	}

	// Check scroll position on mount and scroll
	const checkScroll = () => {
		const el = scrollRef.current;
		if (!el) return;

		setShowLeft(el.scrollLeft > 0);
		setShowRight(Math.round(el.scrollLeft) + el.clientWidth < el.scrollWidth - 1);
	};

	useEffect(() => {
		const STORE_ORIGIN = "https://hof-india-test.myshopify.com";



		// const td = new TextDecoder();

		// function b64ToBytes(b64: string) {
		//     const bin = atob(b64);
		//     const bytes = new Uint8Array(bin.length);
		//     for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
		//     return bytes;
		// }

		// async function importKey() {
		//     return crypto.subtle.importKey(
		//         "raw",
		//         b64ToBytes(KEY_B64),
		//         { name: "AES-GCM" },
		//         false,
		//         ["decrypt"]
		//     );
		// }

		// async function decryptToString(payload: { iv: string; ct: string }) {
		//     const key = await importKey();
		//     const iv = b64ToBytes(payload.iv);
		//     const ct = b64ToBytes(payload.ct);
		//     const plainBuf = await crypto.subtle.decrypt(
		//         { name: "AES-GCM", iv },
		//         key,
		//         ct
		//     );
		//     return td.decode(plainBuf);
		// }

		async function handleEncryptedMessage(event: MessageEvent) {
			if (event.origin !== STORE_ORIGIN) return;


			if (event.data?.type === "SHOPIFY_CUSTOMER_DATA") {
				try {
					// Handle null customer data
					if (event.data.customer === null || event.data.customer === undefined) {
						// Remove existing data if customer is null
						localStorage.removeItem("username");
						setCustomer(null);
						return;
					}

					const encrypted = await encryptJsonAesGcmB64(event.data.customer, KEY_B64);
					const str = JSON.stringify(encrypted);

					const decrypted = await decryptAesGcmB64(encrypted, KEY_B64);
					const decryptedParse = JSON.parse(decrypted);

					localStorage.setItem("username", str);
					setCustomer(event.data.customer);
				} catch (e) {
					console.error("Failed to encrypt customer payload:", e);
				}
			}
		}

		window.addEventListener("message", (e) => { handleEncryptedMessage(e); });

		// Tell parent we're ready
		window.parent.postMessage({ type: "CHATBOT_READY" }, STORE_ORIGIN);

		return () => {
			window.removeEventListener("message", (e) => { handleEncryptedMessage(e); });
		};
	}, []);

	// ElevenLabs API configuration
	const ELEVEN_API_KEY = process.env.REACT_APP_ELEVEN_API_KEY	|| "sk_cfc28fa09746876c70d5070f5b7c8fdee25deab3b54973d6";
	const ELEVEN_MODEL = process.env.REACT_APP_ELEVEN_MODEL || "eleven_multilingual_v2";
	const VOICE_ID = process.env.REACT_APP_ELEVEN_VOICE_ID || "19STyYD15bswVz51nqLf";

	const handleSpeak = async (screenText: any, id: any): Promise<boolean> => {
		if (!screenText || typeof screenText !== "string") {
			return true;
		}

		// Safety check: ensure we have a valid message ID
		if (!id || (typeof id !== "string" && typeof id !== "number")) {
			console.warn('handleSpeak called with invalid or undefined message ID:', id);
			return true;
		}

		// If the same message is already playing, stop it (toggle behavior)
		if (stopId === id && currentAudioRef.current) {
			currentAudioRef.current.pause();
			currentAudioRef.current.currentTime = 0;
			currentAudioRef.current = null;
			dispatch(setStopId(null));
			setIsTTSLoading(false);
			setTtsStatusById(prev => ({
				...prev,
				[id]: 'idle' as const,
			}));
			return true;
		}

		// If another message audio is currently playing, do NOTHING - return early
		// Check if there's an active audio playing for a different message
		// We need to check the current state to see if another message is playing
		if (stopId && stopId !== id && stopId !== '' && stopId !== null) {
			// Check if the other message is actually playing (not just preparing)
			const otherStatus = ttsStatusById[stopId];
			// Only block if there's actually a playing audio element that's not paused
			// This allows new responses to auto-play even if stopId is set (e.g., after stopping previous audio)
			if (otherStatus === 'playing' && currentAudioRef.current && !currentAudioRef.current.paused) {
				return true; // Do nothing, let the current audio continue
			}
		}

		// Bump request id so any in-flight TTS responses from older requests are ignored
		const requestId = ++ttsRequestIdRef.current;

		// Mark this message as "preparing" audio
		setTtsStatusById(prev => ({
			...prev,
			[id]: 'preparing' as const,
		}));

		// Always stop any currently playing audio when starting a new TTS
		// This ensures new responses can auto-play even if there's lingering state
		// Do not invalidate this new TTS request; just stop existing playback/state
		if (currentAudioRef.current || (stopId && stopId !== '' && stopId !== null)) {
			stopTTSPlayback(false);
		}

		// Set loading state to disable inputs
		setIsTTSLoading(true);

		try {
			// Call ElevenLabs API
			const response = await fetch(
				`https://api.elevenlabs.io/v1/text-to-speech/${VOICE_ID}`,
				{
					method: 'POST',
					headers: {
						'Accept': 'audio/mpeg',
						'Content-Type': 'application/json',
						'xi-api-key': ELEVEN_API_KEY
					},
					body: JSON.stringify({
						text: screenText,
						model_id: ELEVEN_MODEL,
						voice_settings: {
							stability: 0.5,
							similarity_boost: 0.75
						}
					})
				}
			);

			if (!response.ok) {
				throw new Error(`ElevenLabs API error: ${response.statusText}`);
			}

			// Get audio blob from response
			const audioBlob = await response.blob();
			const audioUrl = URL.createObjectURL(audioBlob);

			// If a newer TTS request has started since this one, ignore this audio
			if (requestId !== ttsRequestIdRef.current) {
				URL.revokeObjectURL(audioUrl);
				setTtsStatusById(prev => ({
					...prev,
					[id]: 'idle' as const,
				}));
				return true;
			}
			
			// Create audio element and play
			const audio = new Audio(audioUrl);
			currentAudioRef.current = audio;
			dispatch(setStopId(id));
			// Mark as actively playing
			setTtsStatusById(prev => ({
				...prev,
				[id]: 'playing' as const,
			}));

			audio.onended = () => {
				URL.revokeObjectURL(audioUrl);
				currentAudioRef.current = null;
				dispatch(setStopId(null));
				setIsTTSLoading(false); // Ensure inputs are enabled when audio ends
				setTtsStatusById(prev => ({
					...prev,
					[id]: 'idle' as const,
				}));
			};

			audio.onerror = (error) => {
				console.error('Audio playback error:', error);
				URL.revokeObjectURL(audioUrl);
				currentAudioRef.current = null;
				dispatch(setStopId(null));
				setIsTTSLoading(false); // Re-enable inputs on error
				setTtsStatusById(prev => ({
					...prev,
					[id]: 'idle' as const,
				}));
			};

			await audio.play();
			// Audio is now playing; allow user inputs (text/voice) while playback continues
			setIsTTSLoading(false);
			return true;
		} catch (error) {
			console.error('Error with ElevenLabs TTS:', error);
			dispatch(setStopId(null));
			currentAudioRef.current = null;
			setIsTTSLoading(false); // Re-enable inputs on API error
			setTtsStatusById(prev => ({
				...prev,
				[id]: 'idle' as const,
			}));
			return true; // Still return true to show response even if TTS fails
		}
	};

	// Update visibility on mount and when content changes
	useEffect(() => {
		checkScroll();
		const el = scrollRef.current;
		if (!el) return;

		el.addEventListener('scroll', checkScroll);
		window.addEventListener('resize', checkScroll); // Re-check on resize

		return () => {
			el.removeEventListener('scroll', checkScroll);
			window.removeEventListener('resize', checkScroll);
		};
	}, [suggestionList, isAnswerCalling, productList, cartpageVisible]);

	// Reset scroll position when suggestionList changes
	useEffect(() => {
		if (scrollRef.current) {
			scrollRef.current.scrollLeft = 0;
		}
	}, [suggestionList, isAnswerCalling]);

	const scrollLeft = () => {
		scrollRef.current?.scrollBy({ left: -200, behavior: 'smooth' });
	};

	const scrollRight = () => {
		scrollRef.current?.scrollBy({ left: 200, behavior: 'smooth' });
	};

	const productTemplate = (product: any, products: any) => {
		const index = products.indexOf(product);
		return (
			<div className={`product-card`} id={product.variant_id}>
				{/* <div className={`product-card ${activeProduct === product.link ? "active" : ""}`} id={product.link}> */}
				<div className="product-card-wrap" id={index} onClick={() => {
					setActiveIndexBundleProduct(0)
					hanldeProductDetail(product, products);
					setActiveIndex(index);
				}}>
					<figure>
						<span><ImageWithFallback src={product.variant_image !== null ? product.variant_image : defaultImg} fallbackSrc={defaultImg} alt={product.title} /></span>
						{/* <figcaption><p title={product.title}>{product.title?.length > 20 ? `${product.title.slice(0, 20)}...` : product.title}</p><i className="pi pi-shopping-cart" onClick={(e: any) => { e.stopPropagation(); handleAddToCart(product); }} style={{ fontSize: '1.4rem', color: cartProducts.some((newProduct: any) => product.SKU === newProduct.SKU) ? '#00FF00' : 'white', pointerEvents: cartProducts.some((newProduct: any) => product.SKU === newProduct.SKU) ? 'none' : 'visible' }}></i></figcaption> */}
						<figcaption><p title={product.title}>{product.title?.length > 20 ? `${product.title.slice(0, 20)}...` : product.title}</p><i><img src={LinkIconWhite} alt="link-icon" /></i></figcaption>
					</figure>
				</div>
			</div>
		);
	};
	const productDetailTemplate = (product: Product) => {
		// setProductObject(product)
		return (
			<>
				{/* <div className={`product-card ${activeProduct === product.title ? "active" : ""}`} id={product.title}>
                    <div className="product-card-wrap">
                        <figure>
                            <span><img src={product.link} alt={product.title} /></span>
                            <figcaption onClick={() => { hanldeProductDetail(product); setActiveProduct(product.title) }}><p title={product.title}>{product.title.length > 24 ? `${product.title.slice(0, 24)}...` : product.title}</p><i><img src={LinkIconWhite} alt="link-icon" /></i></figcaption>
                        </figure>
                    </div>
                </div> */}
				<div className="product-top">
					<figure>
						<ImageWithFallback src={product.variant_image !== null ? product.variant_image : defaultImg} fallbackSrc={defaultImg} alt={product.title} />
						{/* <img src={product.link} alt={product.title} /> */}
					</figure>
				</div>
			</>
		);
	};

	const handleAnswerResponse = (uid: any, message: any, ans: string) => {
		// handleSpeak(ans.response, uid)
		setTimeout(() => {
			dispatch(
				updateQuestion({ id: uid, question: message, answer: ans, isTyping: "Done", isCsv: "", productType: "product_search" })
			);
			dispatch(handleAnswerCalling(false));
		}, 1000)
	}
	const handleAnswerResponseAdd = (uid: any, message: any, ans: string) => {
		setTimeout(() => {
			dispatch(
				addQuestion({ id: uid, question: message, answer: ans, isTyping: "Done", isCsv: "", productType: "product_search" })
			);
		}, 2000)
	}
	// Notify Shopify storefront (parent) to add items to the real Shopify cart
	const postAddToShopifyCart = (items: { variant_id: string; quantity: number }[]) => {
		try {
			const STORE_ORIGIN = "https://hof-india-test.myshopify.com";
			// Send a structured message to the parent page which should handle cart additions
			window.parent.postMessage(
				{
					type: "ADD_TO_CART",
					payload: {
						items: items.map((i) => ({ variantId: i.variant_id, quantity: i.quantity }))
					}
				},
				STORE_ORIGIN
			);
		} catch (e) {
			// Swallow errors to avoid breaking chat flow
			console.error("Failed to post add-to-cart message to parent:", e);
		}
	}
	const replaceAllWithAsterisks = (str: string) => {
		return str.replace(/./g, '*');
	};
	const secretKey = 'RON__USER__LOGIN';
	const iv = 'BBBBBBBBBBBBBBBB';

	// Helper to stop any currently playing ElevenLabs audio and optionally invalidate in-flight TTS
	const stopTTSPlayback = (invalidateInFlight: boolean = true) => {
		const previousStopId = stopId;

		if (currentAudioRef.current) {
			currentAudioRef.current.pause();
			currentAudioRef.current.currentTime = 0;
			currentAudioRef.current = null;
		}

		// Clear global TTS flags
		dispatch(setStopId(''));
		setIsTTSLoading(false);

		// Reset per-message status for the message that was previously playing
		if (previousStopId) {
			setTtsStatusById(prev => ({
				...prev,
				[previousStopId]: 'idle' as const,
			}));
		}

		// Invalidate any in-flight TTS requests so their audio won't play
		if (invalidateInFlight) {
			ttsRequestIdRef.current++;
		}
	};
	// Function to encrypt the password
	const encryptPassword = (password: string) => {
		const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(secretKey), {
			iv: CryptoJS.enc.Utf8.parse(iv),
			mode: CryptoJS.mode.ECB
		});
		return encrypted.toString();
	};

	const userHandler: any = Cookies.get(`handler_${localStorage.getItem('username')}`); // Retrieve 'user' cookie
	// const firstTimeHandle = async (uniqueId: string, message2: string, validationMessage: string) => {
	//     try {
	//         const { result, error } = await getHandler("", "");
	//         if (error) {
	//             throw error
	//         }
	//         if (result?.error) {
	//             throw result.error
	//         }
	//         await handleAnswerResponse(uniqueId, message2, `${validationMessage} **${result.handler_name}**.`);
	//         const uniqueId2 = uuidv4();
	//         await handleAnswerResponseAdd(uniqueId2, "", `Would you like to update your handle to one of your choice? Please respond with "Yes" or "No".`)
	//         dispatch(controlHandlerState("no_state"));
	//         dispatch(setUserHandlerName(result.handler_name));
	//         dispatch(handleAnswerCalling(false));
	//     } catch (error: any) {
	//         toast.error(error, {
	//             style: {
	//                 backgroundColor: '#F1F1F1', // Grey background
	//             }
	//         })
	//     }
	// }
	const handleClickMessage = async () => {
		if (message) {
			// Requirement: when a new question is sent, immediately stop any playing TTS audio
			stopTTSPlayback(true);
			// if (userHandler !== undefined) {
			//     dispatch(handleIsUserHandler(true));
			// }
			dispatch(handleAnswerCalling(true));
			setMessage("");
			const uniqueId = uuidv4();
			if (!errored && productList?.length === 0 && productCartList?.length === 0) {
				dispatch(
					addQuestion({ id: uniqueId, question: message, answer: "", isTyping: "Typing" })
				);
			}
			let Client: string = "vc";
			// let Client: string = "hof";
			// const env = localStorage.getItem("clientName")
			// if (window.location.origin === 'https://ron.rysun.in:3001' && env === "ron_prod") {
			//     Client = "frida_prod"
			// } else if (window.location.origin !== 'https://ron.rysun.in:3001' && (env === "ron_stage" || env === "ron_dev")) {
			//     Client = "frida"
			// } else {
			//     if (localStorage.getItem("envParam") === "Firstwatch") {
			//         Client = "Firstwatch"
			//     } else {
			//         Client = env
			//     }
			// }

			// const lastQuestionAsked = localStorage.getItem("lastBotQuestion")
			let botId = localStorage.getItem("botId") || "";
			// if (lastQuestionAsked) {
			//     const diffMs = Math.abs(Date.now() - parseInt(lastQuestionAsked));
			//     const seconds = Math.floor(diffMs / 1000);
			//     const minutes = Math.floor(seconds / 60);
			//     if (minutes >= 3) {
			//         if (botId) {
			//             await botAnalysis(botId);
			//             localStorage.removeItem("username");
			//             localStorage.removeItem("chat_access_token");
			//         }
			//         botId = ""
			//         localStorage.removeItem("lastBotQuestion")
			//         setChatToken("")
			//         // localStorage.setItem("botId", "")
			//     }
			// }
			// if (userHandler === undefined) {
			//     if (localStorage.getItem('username') === undefined || localStorage.getItem('username') === null) {
			//         // localStorage.clear()
			//         localStorage.removeItem('access_token');
			//         localStorage.removeItem('announcements');
			//         localStorage.removeItem('clientName');
			//         localStorage.removeItem('default_label');
			//         localStorage.removeItem('default_questions');
			//         localStorage.removeItem('feature-flag');
			//         localStorage.removeItem('firstName');
			//         localStorage.removeItem('isLogged');
			//         localStorage.removeItem('lastActivity');
			//         localStorage.removeItem('lastName');
			//         localStorage.removeItem('loginTime');
			//         localStorage.removeItem('logos');
			//         localStorage.removeItem('permissions');
			//         localStorage.removeItem('refresh_token');
			//         localStorage.removeItem('username');
			//         localStorage.removeItem('lastBotQuestion');
			//         localStorage.removeItem('botId');
			//         localStorage.removeItem("wrongAttempt");
			//         localStorage.removeItem("attempt");
			//         localStorage.removeItem('handler_name_exist');
			//         localStorage.removeItem("false_attempt");
			//         localStorage.removeItem("user_name_attempts")
			//         // localStorage.removeItem("username");
			//         localStorage.removeItem("chat_access_token");
			//         // window.location.href = '/login'
			//     }
			//     dispatch(setIsNewConversation("old"));
			//     // if (noSynonyms.some((i: string) => message.toLowerCase().includes(i)) && handlerState === "") {
			//     if (noSynonyms.includes(message.toLowerCase()) && handlerState === "") {
			//         firstTimeHandle(uniqueId, message, "To personalize your chat experience, we have assigned you a handle:");
			//         // } else if (yesSynonyms.some((i: string) => message.toLowerCase().includes(i)) && handlerState === "") {
			//     } else if (yesSynonyms.includes(message.toLowerCase()) && handlerState === "") {
			//         handleAnswerResponse(uniqueId, message, `Please provide your handle. You have 2 attempts to enter a valid handle.`);
			//         dispatch(controlHandlerState("yes_state"));
			//         dispatch(handleAnswerCalling(false));
			//         // handleAnswerResponse(uniqueId, message, "Kindly provide the correct display name to submit your questions.")
			//     } else {
			//         if (handlerState === "") {
			//             const wrongAttempt = localStorage.getItem("wrongAttempt");
			//             if (wrongAttempt === null) {
			//                 localStorage.setItem("wrongAttempt", '1')
			//                 handleAnswerResponse(uniqueId, message, `Please provide a valid response. You have only 1 attempt remaining.`);
			//                 dispatch(handleAnswerCalling(false));
			//             } else if (wrongAttempt === '1') {
			//                 handleAnswerResponse(uniqueId, message, `You have entered an incorrect response twice, exceeding the allowed limit.`);
			//                 const uniqueId2 = uuidv4();
			//                 setTimeout(() => {
			//                     dispatch(
			//                         addQuestion({ id: uniqueId2, question: "", answer: "", isTyping: "Typing" })
			//                     );
			//                     firstTimeHandle(uniqueId2, "", "To ensure a seamless experience, we have now assigned you a new handle:");
			//                     localStorage.removeItem("wrongAttempt");
			//                 }, 2000)
			//             }
			//         } else if (handlerState === "yes_state") {
			//             try {
			//                 const { result, error } = await getHandler(message.toUpperCase(), "");
			//                 if (error) {
			//                     throw error
			//                 }
			//                 if (result?.error) {
			//                     throw result.error
			//                 }
			//                 dispatch(handleAnswerCalling(false));
			//             } catch (error: any) {
			//                 if (error === "handler_name already exists") {
			//                     handleAnswerResponse(uniqueId, message, `Welcome back **${message.toUpperCase()}**!`);
			//                     Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, message.toUpperCase(), { expires: 1000 });
			//                     dispatch(controlHandlerState(""));
			//                     dispatch(handleAnswerCalling(false));
			//                 } else if (error === "handler_name does not exists") {
			//                     const attempts = localStorage.getItem("attempt");
			//                     if (attempts === null) {
			//                         localStorage.setItem("attempt", '1')
			//                         handleAnswerResponse(uniqueId, message, `The handle **${message.toUpperCase()}** does not exist. Please enter a valid handle. You have only 1 attempt remaining.`);
			//                     } else if (attempts === '1') {
			//                         handleAnswerResponse(uniqueId, message, `The handle **${message.toUpperCase()}** does not exist. You have entered an incorrect handle twice, exceeding the allowed limit.`);
			//                         const uniqueId2 = uuidv4();
			//                         setTimeout(() => {
			//                             dispatch(
			//                                 addQuestion({ id: uniqueId2, question: "", answer: "", isTyping: "Typing" })
			//                             );
			//                             firstTimeHandle(uniqueId2, "", "To ensure a seamless experience, we have now assigned you a new handle:");
			//                             localStorage.removeItem("attempt");
			//                         }, 2000)
			//                     }
			//                 } else {
			//                     toast.error(error, {
			//                         style: {
			//                             backgroundColor: '#F1F1F1', // Grey background
			//                         }
			//                     })
			//                 }
			//             }
			//         } else if (handlerState === "no_state") {
			//             // if (noSynonyms.some((i: string) => message.toLowerCase().includes(i))) {
			//             if (noSynonyms.includes(message.toLowerCase())) {
			//                 handleAnswerResponse(uniqueId, message, `Welcome to ShopMate **${userHandlerName}**.`);
			//                 Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, userHandlerName, { expires: 1000 });
			//                 dispatch(controlHandlerState(""));
			//                 // } else if (yesSynonyms.some((i: string) => message.toLowerCase().includes(i))) {
			//             } else if (yesSynonyms.includes(message.toLowerCase())) {
			//                 handleAnswerResponse(uniqueId, message, `Please enter the handle of your choice. You have 2 attempts to enter a valid choice. Handle must be alphanumeric and between 8 to 10 characters long. Special characters and handles shorter than 8 digits and longer than 10 digits are not allowed.`);
			//             } else {
			//                 if (/^[a-zA-Z0-9]{8,10}$/.test(message)) {
			//                     try {
			//                         const { result, error } = await getHandler(message.toUpperCase(), userHandlerName);
			//                         if (error) {
			//                             throw error
			//                         }
			//                         if (result?.error) {
			//                             throw result.error
			//                         }
			//                         await handleAnswerResponse(uniqueId, message, `Your handle has been successfully updated from **${userHandlerName}** to **${result.handler_name}**.`);
			//                         const uniqueId2 = uuidv4();
			//                         await handleAnswerResponseAdd(uniqueId2, "", `Welcome to ShopMate **${result.handler_name}**.`);
			//                         dispatch(controlHandlerState(""));
			//                         Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, result.handler_name, { expires: 1000 });
			//                     } catch (error: any) {
			//                         if (error === "handler_name already exists") {
			//                             const handler_name_exist = localStorage.getItem("handler_name_exist");
			//                             if (handler_name_exist === null) {
			//                                 localStorage.setItem('handler_name_exist', '1')
			//                                 handleAnswerResponse(uniqueId, message, `This handle already exists. Please try a different one. You have only 1 attempt remaining.`);
			//                             } else if (handler_name_exist === '1') {
			//                                 localStorage.removeItem('handler_name_exist');
			//                                 await handleAnswerResponse(uniqueId, message, `This handle already exists.`);
			//                                 const uniqueId2 = uuidv4();
			//                                 await handleAnswerResponseAdd(uniqueId2, "", `You have added existed handle twice. To ensure a seamless exeperiance, we have assigned you the handle: **${userHandlerName}**.`);
			//                                 Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, userHandlerName, { expires: 1000 });
			//                                 dispatch(controlHandlerState(""));
			//                             }
			//                         } else {
			//                             toast.error(error, {
			//                                 style: {
			//                                     backgroundColor: '#F1F1F1', // Grey background
			//                                 }
			//                             })
			//                         }
			//                     }
			//                 } else {
			//                     const false_attempt = localStorage.getItem("false_attempt")
			//                     if (false_attempt === null) {
			//                         localStorage.setItem("false_attempt", '1')
			//                         handleAnswerResponse(uniqueId, message, `The handle must be alphanumeric and between 8 to 10 characters long. Special characters and handles outside this range are not allowed. You have only 1 attempt remaining.`);
			//                     } else if (false_attempt === '1') {
			//                         localStorage.removeItem("false_attempt");
			//                         await handleAnswerResponse(uniqueId, message, `Handle must be alphanumeric and between 8 to 10 characters long. Special characters and handles outside this range are not allowed.`);
			//                         const uniqueId2 = uuidv4();
			//                         await handleAnswerResponseAdd(uniqueId2, "", `You have entered an invalid pattern twice. To ensure a seamless exeperiance, we have assigned you the handle: **${userHandlerName}**.`);
			//                         Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, userHandlerName, { expires: 1000 });
			//                         dispatch(controlHandlerState(""));
			//                     }
			//                 }
			//             }
			//         }

			//     }
			// } else {

			// dispatch(controlHandlerState(""));
			if (Object.keys(addToCartObj)?.length !== 0) {
				if (yesSynonyms.some((i: string) => message.toLowerCase().includes(i))) {
					try {
						const body = {
							client_env: localStorage.getItem("clientName"),
							handler_name: userHandler,
							product_id: `${addToCartObj.variant_id}`,
							conversation_id: botId
						}
						const { result, error } = await user_story_bundling_api(body);
						dispatch(addOrRemoveObjectForAddToCart({}));
						if (error) {
							throw error
						}
						if (result?.error) {
							throw result.error
						}
						if (result?.results === "something went wrong") {
							throw result.results
						}
						dispatch(
							updateQuestion({
								id: uniqueId,
								question: message,
								answer: `Great! Here are some products related to your preference for ${addToCartObj.title}.`,
								isTyping: "Done",
								is_file: false,
								productType: "product_recommendation",
								products: result?.results,
							})
						);
						dispatch(handleAnswerCalling(false));
					} catch (error: any) {
						dispatch(setSuggestionList([]));
						// toast.error(error, {
						//     style: {
						//         backgroundColor: '#F1F1F1', // Grey background
						//     }
						// })
						dispatch(
							updateQuestion({
								id: uniqueId,
								question: message,
								answer: error,
								isTyping: "Done",
								is_file: false,
								productType: "product_search",
								// products: result?.results,
							})
						);
						dispatch(handleAnswerCalling(false));
					}
				} else {
					dispatch(addOrRemoveObjectForAddToCart({}));
					handleAnswerResponse(uniqueId, message, `Awesome! If you need any more help or have questions about anything else, feel free to ask.`);
					// dispatch(
					//     updateQuestion({
					//         id: uniqueId,
					//         question: message,
					//         answer: "Awesome! If you need any more help or have questions about anything else, feel free to ask.",
					//         isTyping: "Done",
					//         is_file: "",
					//         productType: "product_search"
					//     })
					// );
				}
			} else {
				if (productList?.length > 0 || productCartList?.length > 0) {
					const uniqueId = uuidv4();
					dispatch(
						addProductPageQuestion({ id: uniqueId, question: message, answer: "", isTyping: "Typing" })
					);
					let depCustomerParse = ""
					if (localStorage.getItem("username")) {
						const depCustomer = await decryptAesGcmB64(JSON.parse(localStorage.getItem("username") as any), KEY_B64);
						depCustomerParse = JSON.parse(depCustomer).email;
					}
					const data = {
						client_env: 'hof',
						user_name: depCustomerParse ?? '',
						context: [singleProduct],
						question: message
					}
					try {
						const { result, error } = await botProductPageChat(data);
						if (error) {
							throw error
						}
						if (result?.error) {
							throw result.error
						}
						dispatch(
							updateProductPageQuestion({
								id: uniqueId,
								question: message,
								answer: result,
								isTyping: "Done",
								is_file: false,
								productType: "product_search",
							})
						);
						dispatch(handleAnswerCalling(false));

					} catch (error: any) {
						dispatch(
							updateProductPageQuestion({
								id: uniqueId,
								question: message,
								answer: error,
								isTyping: "Done",
								productType: "product_search",
							})
						);
						dispatch(handleAnswerCalling(false));
						return {};
					}
				} else {
					try {
						let depCustomerParse = ""
						if (localStorage.getItem("username")) {
							const depCustomer = await decryptAesGcmB64(JSON.parse(localStorage.getItem("username") as any), KEY_B64);
							depCustomerParse = JSON.parse(depCustomer).email;
						}
						const body: any = {
							user_id: localStorage.getItem('user_id'),
							session_id: localStorage.getItem('session_id'),
							question: message,
							group: (isAuthDetails?.group_name || '').toLowerCase(),
							// title: message,
							is_chart_chat: false

						}
						if (conversation_id !== 'new-chat') {
							body.conversation_id = conversation_id
						}
						if (chatTitle !== '') {
							body.title = chatTitle
						}
						const { result, error } = await createConversation(body);
						await fetchChatSessions();
						// const { result, error } = await getAnswer(encodeURIComponent(message), Client, botId ? botId : "", depCustomerParse ?? "", userHandler);
						if (error) {
							throw error
						}
						if (result?.error) {
							throw result.error
						}
						// setChatTitle()
						localStorage.setItem('lastBotQuestion', String(Date.now()));
						localStorage.setItem("botId", result.conversation_id)
						if (result?.answer === "PER_INFO") {
							dispatch(handleBotLoginQue(message))
							if(ishandleModeDetails === 'voice' || ishandleModeDetails === 'hybrid'){
							await handleSpeak("Please provide me your Email Id!", uniqueId)
							}
							dispatch(
								updateQuestion({
									id: uniqueId,
									question: message,
									answer: "Please provide me your Email Id!",
									isTyping: "Done",
									productType: "product_search"
								})
							);
							setError(true);
							dispatch(handleAnswerCalling(false));
						} else {
							if (result?.is_recommend) {
								if (result?.message !== null && result?.message !== "") {
								if(ishandleModeDetails === 'voice' || ishandleModeDetails === 'hybrid'){
								await handleSpeak(result?.message, uniqueId)
								}
								dispatch(
									updateQuestion({
										id: uniqueId,
										question: message,
										answer: result?.message,
										isTyping: "Done",
										is_file: false,
										productType: "product_recommendation",
										products: result.answer,
									})
								);
								dispatch(setSuggestionList(result.suggested_questions))
								dispatch(handleAnswerCalling(false));
							} else {
								if(ishandleModeDetails === 'voice' || ishandleModeDetails === 'hybrid'){
								await handleSpeak("Certainly! Here are some suggestions:", uniqueId)
								}
								dispatch(
									updateQuestion({
										id: uniqueId,
										question: message,
										answer: "Certainly! Here are some suggestions:",
										isTyping: "Done",
										is_file: false,
										productType: "product_recommendation",
										products: result.answer,
									})
								);
								dispatch(setSuggestionList(result.suggested_questions))
								dispatch(handleAnswerCalling(false));
							}
							} else if (result?.is_cart) {
								dispatch(setSuggestionList(result.suggested_questions))
								// Assuming cartProducts is an array of objects with a unique 'id'
								const newProducts = result.answer.products_added;
								const sameProducts = newProducts.filter(
									(newProd: any) => cartProducts.some((existingProd: any) => existingProd.variant_id === newProd.variant_id)
								);
								const diffProducts = newProducts.filter(
									(newProd: any) => cartProducts.every((existingProd: any) => existingProd.variant_id !== newProd.variant_id)
								);
								if (sameProducts?.length > 0) {
									const manyReturn = (many: string, much: string, products: any) => {
										if (products?.length > 1) {
											return many
										} else {
											return much
										}
									}
									if (diffProducts.length === 0) {
										dispatch(
											updateQuestion({
												id: uniqueId,
												question: message,
												answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.title).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart.`,
												isTyping: "Done",
												is_file: result.is_file,
												productType: "product_search"
											})
										);
									} else {
										dispatch(
											updateQuestion({
												id: uniqueId,
												question: message,
												answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.title).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart.\n\n---\n\nGreat choice! The following ${manyReturn('products', 'product', diffProducts)} ${manyReturn('have', 'has', diffProducts)} been added to your cart: **${diffProducts.map((product: any) => product.title).join(', ')}**`,
												isTyping: "Done",
												is_file: result.is_file,
												productType: "product_search"
											})
										);
										// Filter out duplicates before adding
										const filteredNewProducts = newProducts.filter(
											(newProd: any) => !cartProducts.some((existingProd: any) => existingProd.variant_id === newProd.variant_id)
										);

										setCartsProduct([...cartProducts, ...filteredNewProducts]);
										const finalArray = [...cartProducts, ...filteredNewProducts]
										localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(finalArray))
										// Mirror bulk add to Shopify cart
										postAddToShopifyCart(filteredNewProducts.map((p: any) => ({ variant_id: p.variant_id, quantity: 1 })));
									}
									dispatch(handleAnswerCalling(false));
								} else {
									dispatch(setSuggestionList(result.suggested_questions))
									dispatch(
										updateQuestion({
											id: uniqueId,
											question: message,
											answer: result.message,
											isTyping: "Done",
											is_file: result.is_file,
											productType: "product_search"
										})
									);

									// Filter out duplicates before adding
									const filteredNewProducts = newProducts.filter(
										(newProd: any) => !cartProducts.some((existingProd: any) => existingProd.variant_id === newProd.variant_id)
									);

									setCartsProduct([...cartProducts, ...filteredNewProducts]);
									const finalArray = [...cartProducts, ...filteredNewProducts]
									localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(finalArray))
									// Mirror bulk add to Shopify cart
									postAddToShopifyCart(filteredNewProducts.map((p: any) => ({ variant_id: p.variant_id, quantity: 1 })));
									dispatch(handleAnswerCalling(false));
								}
							} else {
								if (localStorage.getItem("clientName") !== "InzaloEMS") {
									dispatch(setSuggestionList(result.suggested_questions))
									if(ishandleModeDetails === 'voice' || ishandleModeDetails === 'hybrid'){
									await handleSpeak(result?.response, uniqueId)
									}
									dispatch(
										updateQuestion({
											id: uniqueId,
											question: message,
											answer: result,
											isTyping: "Done",
											is_file: result.is_file,
											productType: "product_search"
										})
									);
									dispatch(handleAnswerCalling(false));
								} else {
									if(ishandleModeDetails === 'voice' || ishandleModeDetails === 'hybrid'){
									await handleSpeak(result?.response, uniqueId)
									}
									dispatch(
										updateQuestion({
											id: uniqueId,
											question: message,
											answer: result,
											isTyping: "Done",
											is_file: result.is_file,
											productType: "product_search"
										})
									);
									dispatch(handleAnswerCalling(false));

								}
							}
						}

					} catch (error: any) {
						dispatch(setSuggestionList([]));
						if (error === "Need to login") {
							dispatch(handleBotLoginQue(message))
							dispatch(
								updateQuestion({
									id: uniqueId,
									question: message,
									answer: "Please provide me your Email Id!",
									isTyping: "Done",
									productType: "product_search"
								})
							);
							dispatch(handleAnswerCalling(false));
							setError(true);
						} else {
							// Handle other errors
							dispatch(
								updateQuestion({
									id: uniqueId,
									question: message,
									answer: error,
									isTyping: "Done",
									productType: "product_search"
								})
							);
							dispatch(handleAnswerCalling(false));
						}
						return {};
					}
				}
			}
			// }

		}

	}
	const handleClickMessageSuggestion = async (suggestion: string) => {
		// Requirement: when a new question is sent (via suggestion), stop any playing TTS audio
		stopTTSPlayback(true);
		dispatch(handleAnswerCalling(true));
		setMessage("");
		const uniqueId = uuidv4();
		if (!errored && productList?.length === 0 && productCartList?.length === 0) {
			dispatch(
				addQuestion({ id: uniqueId, question: suggestion, answer: "", isTyping: "Typing" })
			);
		}
		let Client: string | null = "hof";
		// const env = localStorage.getItem("clientName")
		// if (window.location.origin === 'https://ron.rysun.in:3001' && env === "ron_prod") {
		//     Client = "frida_prod"
		// } else if (window.location.origin !== 'https://ron.rysun.in:3001' && (env === "ron_stage" || env === "ron_dev")) {
		//     Client = "frida"
		// } else {
		//     if (localStorage.getItem("envParam") === "Firstwatch") {
		//         Client = "Firstwatch"
		//     } else {
		//         Client = env
		//     }
		// }

		// const lastQuestionAsked = localStorage.getItem("lastBotQuestion")
		let botId = localStorage.getItem("botId") || "";
		// if (lastQuestionAsked) {
		//     const diffMs = Math.abs(Date.now() - parseInt(lastQuestionAsked));
		//     const seconds = Math.floor(diffMs / 1000);
		//     const minutes = Math.floor(seconds / 60);
		//     if (minutes >= 3) {
		//         if (botId) {
		//             await botAnalysis(botId);
		//             localStorage.removeItem("username");
		//             localStorage.removeItem("chat_access_token");
		//         }
		//         botId = ""
		//         localStorage.removeItem("lastBotQuestion")
		//         setChatToken("")
		//         // localStorage.setItem("botId", "")
		//     }
		// }
		// if (userHandler === undefined) {
		//     if (localStorage.getItem('username') === undefined || localStorage.getItem('username') === null) {
		//         // localStorage.clear()
		//         localStorage.removeItem('access_token');
		//         localStorage.removeItem('announcements');
		//         localStorage.removeItem('clientName');
		//         localStorage.removeItem('default_label');
		//         localStorage.removeItem('default_questions');
		//         localStorage.removeItem('feature-flag');
		//         localStorage.removeItem('firstName');
		//         localStorage.removeItem('isLogged');
		//         localStorage.removeItem('lastActivity');
		//         localStorage.removeItem('lastName');
		//         localStorage.removeItem('loginTime');
		//         localStorage.removeItem('logos');
		//         localStorage.removeItem('permissions');
		//         localStorage.removeItem('refresh_token');
		//         localStorage.removeItem('username');
		//         localStorage.removeItem('lastBotQuestion');
		//         localStorage.removeItem('botId');
		//         localStorage.removeItem("wrongAttempt");
		//         localStorage.removeItem("attempt");
		//         localStorage.removeItem('handler_name_exist');
		//         localStorage.removeItem("false_attempt");
		//         localStorage.removeItem("user_name_attempts")
		//         localStorage.removeItem("username");
		//         localStorage.removeItem("chat_access_token");
		//         window.location.href = '/login'
		//     }
		//     dispatch(setIsNewConversation("old"));
		//     // if (noSynonyms.some((i: string) => message.toLowerCase().includes(i)) && handlerState === "") {
		//     if (noSynonyms.includes(suggestion.toLowerCase()) && handlerState === "") {
		//         firstTimeHandle(uniqueId, suggestion, "To personalize your chat experience, we have assigned you a handle:");
		//         // } else if (yesSynonyms.some((i: string) => message.toLowerCase().includes(i)) && handlerState === "") {
		//     } else if (yesSynonyms.includes(suggestion.toLowerCase()) && handlerState === "") {
		//         handleAnswerResponse(uniqueId, suggestion, `Please provide your handle. You have 2 attempts to enter a valid handle.`);
		//         dispatch(controlHandlerState("yes_state"));
		//         dispatch(handleAnswerCalling(false));
		//         // handleAnswerResponse(uniqueId, message, "Kindly provide the correct display name to submit your questions.")
		//     } else {
		//         if (handlerState === "") {
		//             const wrongAttempt = localStorage.getItem("wrongAttempt");
		//             if (wrongAttempt === null) {
		//                 localStorage.setItem("wrongAttempt", '1')
		//                 handleAnswerResponse(uniqueId, suggestion, `Please provide a valid response. You have only 1 attempt remaining.`);
		//                 dispatch(handleAnswerCalling(false));
		//             } else if (wrongAttempt === '1') {
		//                 handleAnswerResponse(uniqueId, suggestion, `You have entered an incorrect response twice, exceeding the allowed limit.`);
		//                 const uniqueId2 = uuidv4();
		//                 setTimeout(() => {
		//                     dispatch(
		//                         addQuestion({ id: uniqueId2, question: "", answer: "", isTyping: "Typing" })
		//                     );
		//                     firstTimeHandle(uniqueId2, "", "To ensure a seamless experience, we have now assigned you a new handle:");
		//                     localStorage.removeItem("wrongAttempt");
		//                 }, 2000)
		//             }
		//         } else if (handlerState === "yes_state") {
		//             try {
		//                 const { result, error } = await getHandler(suggestion.toUpperCase(), "");
		//                 if (error) {
		//                     throw error
		//                 }
		//                 if (result?.error) {
		//                     throw result.error
		//                 }
		//                 dispatch(handleAnswerCalling(false));
		//             } catch (error: any) {
		//                 if (error === "handler_name already exists") {
		//                     handleAnswerResponse(uniqueId, suggestion, `Welcome back **${suggestion.toUpperCase()}**!`);
		//                     Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, suggestion.toUpperCase(), { expires: 1000 });
		//                     dispatch(controlHandlerState(""));
		//                     dispatch(handleAnswerCalling(false));
		//                 } else if (error === "handler_name does not exists") {
		//                     const attempts = localStorage.getItem("attempt");
		//                     if (attempts === null) {
		//                         localStorage.setItem("attempt", '1')
		//                         handleAnswerResponse(uniqueId, suggestion, `The handle **${suggestion.toUpperCase()}** does not exist. Please enter a valid handle. You have only 1 attempt remaining.`);
		//                     } else if (attempts === '1') {
		//                         handleAnswerResponse(uniqueId, suggestion, `The handle **${suggestion.toUpperCase()}** does not exist. You have entered an incorrect handle twice, exceeding the allowed limit.`);
		//                         const uniqueId2 = uuidv4();
		//                         setTimeout(() => {
		//                             dispatch(
		//                                 addQuestion({ id: uniqueId2, question: "", answer: "", isTyping: "Typing" })
		//                             );
		//                             firstTimeHandle(uniqueId2, "", "To ensure a seamless experience, we have now assigned you a new handle:");
		//                             localStorage.removeItem("attempt");
		//                         }, 2000)
		//                     }
		//                 } else {
		//                     toast.error(error, {
		//                         style: {
		//                             backgroundColor: '#F1F1F1', // Grey background
		//                         }
		//                     })
		//                 }
		//             }
		//         } else if (handlerState === "no_state") {
		//             // if (noSynonyms.some((i: string) => message.toLowerCase().includes(i))) {
		//             if (noSynonyms.includes(suggestion.toLowerCase())) {
		//                 handleAnswerResponse(uniqueId, suggestion, `Welcome to ShopMate **${userHandlerName}**.`);
		//                 Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, userHandlerName, { expires: 1000 });
		//                 dispatch(controlHandlerState(""));
		//                 // } else if (yesSynonyms.some((i: string) => suggestion.toLowerCase().includes(i))) {
		//             } else if (yesSynonyms.includes(suggestion.toLowerCase())) {
		//                 handleAnswerResponse(uniqueId, suggestion, `Please enter the handle of your choice. You have 2 attempts to enter a valid choice. Handle must be alphanumeric and between 8 to 10 characters long. Special characters and handles shorter than 8 digits and longer than 10 digits are not allowed.`);
		//             } else {
		//                 if (/^[a-zA-Z0-9]{8,10}$/.test(suggestion)) {
		//                     try {
		//                         const { result, error } = await getHandler(suggestion.toUpperCase(), userHandlerName);
		//                         if (error) {
		//                             throw error
		//                         }
		//                         if (result?.error) {
		//                             throw result.error
		//                         }
		//                         await handleAnswerResponse(uniqueId, suggestion, `Your handle has been successfully updated from **${userHandlerName}** to **${result.handler_name}**.`);
		//                         const uniqueId2 = uuidv4();
		//                         await handleAnswerResponseAdd(uniqueId2, "", `Welcome to ShopMate **${result.handler_name}**.`);
		//                         dispatch(controlHandlerState(""));
		//                         Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, result.handler_name, { expires: 1000 });
		//                     } catch (error: any) {
		//                         if (error === "handler_name already exists") {
		//                             const handler_name_exist = localStorage.getItem("handler_name_exist");
		//                             if (handler_name_exist === null) {
		//                                 localStorage.setItem('handler_name_exist', '1')
		//                                 handleAnswerResponse(uniqueId, suggestion, `This handle already exists. Please try a different one. You have only 1 attempt remaining.`);
		//                             } else if (handler_name_exist === '1') {
		//                                 localStorage.removeItem('handler_name_exist');
		//                                 await handleAnswerResponse(uniqueId, suggestion, `This handle already exists.`);
		//                                 const uniqueId2 = uuidv4();
		//                                 await handleAnswerResponseAdd(uniqueId2, "", `You have added existed handle twice. To ensure a seamless exeperiance, we have assigned you the handle: **${userHandlerName}**.`);
		//                                 Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, userHandlerName, { expires: 1000 });
		//                                 dispatch(controlHandlerState(""));
		//                             }
		//                         } else {
		//                             toast.error(error, {
		//                                 style: {
		//                                     backgroundColor: '#F1F1F1', // Grey background
		//                                 }
		//                             })
		//                         }
		//                     }
		//                 } else {
		//                     const false_attempt = localStorage.getItem("false_attempt")
		//                     if (false_attempt === null) {
		//                         localStorage.setItem("false_attempt", '1')
		//                         handleAnswerResponse(uniqueId, suggestion, `The handle must be alphanumeric and between 8 to 10 characters long. Special characters and handles outside this range are not allowed. You have only 1 attempt remaining.`);
		//                     } else if (false_attempt === '1') {
		//                         localStorage.removeItem("false_attempt");
		//                         await handleAnswerResponse(uniqueId, suggestion, `Handle must be alphanumeric and between 8 to 10 characters long. Special characters and handles outside this range are not allowed.`);
		//                         const uniqueId2 = uuidv4();
		//                         await handleAnswerResponseAdd(uniqueId2, "", `You have entered an invalid pattern twice. To ensure a seamless exeperiance, we have assigned you the handle: **${userHandlerName}**.`);
		//                         Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, userHandlerName, { expires: 1000 });
		//                         dispatch(controlHandlerState(""));
		//                     }
		//                 }
		//             }
		//         }

		//     }
		// } else {
		// dispatch(controlHandlerState(""));
		if (Object.keys(addToCartObj).length !== 0) {
			if (yesSynonyms.some((i: string) => suggestion.toLowerCase().includes(i))) {
				try {
					const body = {
						client_env: localStorage.getItem("clientName"),
						handler_name: userHandler,
						product_id: `${addToCartObj.variant_id}`,
						conversation_id: botId
					}
					const { result, error } = await user_story_bundling_api(body);
					dispatch(addOrRemoveObjectForAddToCart({}));
					if (error) {
						throw error
					}
					if (result?.error) {
						throw result.error
					}
					if (result?.results === "something went wrong") {
						throw result.results
					}
					dispatch(
						updateQuestion({
							id: uniqueId,
							question: suggestion,
							answer: `Great! Here are some products related to your preference for ${addToCartObj.title}.`,
							isTyping: "Done",
							is_file: false,
							productType: "product_recommendation",
							products: result?.results,
						})
					);
					dispatch(handleAnswerCalling(false));
				} catch (error: any) {
					// toast.error(error, {
					//     style: {
					//         backgroundColor: '#F1F1F1', // Grey background
					//     }
					// })
					dispatch(
						updateQuestion({
							id: uniqueId,
							question: suggestion,
							answer: error,
							isTyping: "Done",
							is_file: false,
							productType: "product_search",
							// products: result?.results,
						})
					);
					dispatch(handleAnswerCalling(false));
				}
			} else {
				dispatch(addOrRemoveObjectForAddToCart({}));
				handleAnswerResponse(uniqueId, suggestion, `Awesome! If you need any more help or have questions about anything else, feel free to ask.`);
				// dispatch(
				//     updateQuestion({
				//         id: uniqueId,
				//         question: message,
				//         answer: "Awesome! If you need any more help or have questions about anything else, feel free to ask.",
				//         isTyping: "Done",
				//         is_file: "",
				//         productType: "product_search"
				//     })
				// );
			}
		} else {
			if (productList?.length > 0 || productCartList?.length > 0) {
				const uniqueId = uuidv4();
				dispatch(
					addProductPageQuestion({ id: uniqueId, question: message, answer: "", isTyping: "Typing" })
				);
				const data = {
					client_env: 'hof',
					user_name: localStorage.getItem("username") ?? '',
					context: [singleProduct],
					question: message
				}
				try {
					const { result, error } = await botProductPageChat(data);
					if (error) {
						throw error
					}
					if (result?.error) {
						throw result.error
					}
					dispatch(
						updateProductPageQuestion({
							id: uniqueId,
							question: message,
							answer: result.response,
							isTyping: "Done",
							is_file: false,
							productType: "product_search",
						})
					);
					dispatch(handleAnswerCalling(false));

				} catch (error: any) {
					dispatch(
						updateProductPageQuestion({
							id: uniqueId,
							question: message,
							answer: error,
							isTyping: "Done",
							productType: "product_search",
						})
					);
					dispatch(handleAnswerCalling(false));
					return {};
				}
			} else {
				try {
					let depCustomerParse = ""
					if (localStorage.getItem("username")) {
						const depCustomer = await decryptAesGcmB64(JSON.parse(localStorage.getItem("username") as any), KEY_B64);
						depCustomerParse = JSON.parse(depCustomer).email;
					}
					const body: any = {
						user_id: localStorage.getItem('user_id'),
						session_id: localStorage.getItem('session_id'),
						question: suggestion,
						group: (isAuthDetails?.group_name || '').toLowerCase(),
						// title: message,
						is_chart_chat: false

					}
					if (conversation_id !== 'new-chat') {
						body.conversation_id = conversation_id
					}
					if (chatTitle !== '') {
						body.title = chatTitle
					}
					const { result, error } = await createConversation(body);
					await fetchChatSessions();
					// const { result, error } = await getAnswer(encodeURIComponent(suggestion), Client, botId ? botId : "", depCustomerParse ?? "", userHandler);
					if (error) {
						throw error
					}
					if (result?.error) {
						throw result.error
					}
					localStorage.setItem('lastBotQuestion', String(Date.now()));
					localStorage.setItem("botId", result.conversation_id)
					if (result?.answer === "PER_INFO") {
						dispatch(handleBotLoginQue(suggestion))
						dispatch(
							updateQuestion({
								id: uniqueId,
								question: suggestion,
								answer: "Please provide me your Email Id!",
								isTyping: "Done",
								productType: "product_search"
							})
						);
						setError(true);
						dispatch(handleAnswerCalling(false));
					} else {
						if (result?.is_recommend) {
							if (result?.message !== null) {
								dispatch(
									updateQuestion({
										id: uniqueId,
										question: suggestion,
										answer: result?.message,
										isTyping: "Done",
										is_file: false,
										productType: "product_recommendation",
										products: result.answer,
									})
								);
								dispatch(setSuggestionList(result.suggested_questions))
								dispatch(handleAnswerCalling(false));
							} else {
								dispatch(
									updateQuestion({
										id: uniqueId,
										question: suggestion,
										answer: "Certainly! Here are some suggestions:",
										isTyping: "Done",
										is_file: false,
										productType: "product_recommendation",
										products: result.answer,
									})
								);
								dispatch(handleAnswerCalling(false));
							}
							dispatch(setSuggestionList(result.suggested_questions))
						} else if (result?.is_cart) {
							dispatch(setSuggestionList(result.suggested_questions))
							// Assuming cartProducts is an array of objects with a unique 'id'
							const newProducts = result.answer.products_added;
							const sameProducts = newProducts.filter(
								(newProd: any) => cartProducts.some((existingProd: any) => existingProd.variant_id === newProd.variant_id)
							);
							const diffProducts = newProducts.filter(
								(newProd: any) => cartProducts.every((existingProd: any) => existingProd.variant_id !== newProd.variant_id)
							);
							if (sameProducts.length > 0) {
								const manyReturn = (many: string, much: string, products: any) => {
									if (products.length > 1) {
										return many
									} else {
										return much
									}
								}
								if (diffProducts.length === 0) {
									dispatch(
										updateQuestion({
											id: uniqueId,
											question: suggestion,
											answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.title).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart.`,
											isTyping: "Done",
											is_file: result.is_file,
											productType: "product_search"
										})
									);
								} else {
									dispatch(
										updateQuestion({
											id: uniqueId,
											question: suggestion,
											answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.title).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart.\n\n---\n\nGreat choice! The following ${manyReturn('products', 'product', diffProducts)} ${manyReturn('have', 'has', diffProducts)} been added to your cart: **${diffProducts.map((product: any) => product.title).join(', ')}**`,
											isTyping: "Done",
											is_file: result.is_file,
											productType: "product_search"
										})
									);
									// Filter out duplicates before adding
									const filteredNewProducts = newProducts.filter(
										(newProd: any) => !cartProducts.some((existingProd: any) => existingProd.variant_id === newProd.variant_id)
									);

									setCartsProduct([...cartProducts, ...filteredNewProducts]);
									const finalArray = [...cartProducts, ...filteredNewProducts]
									localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(finalArray))
									// Mirror bulk add to Shopify cart
									postAddToShopifyCart(filteredNewProducts.map((p: any) => ({ variant_id: p.variant_id, quantity: 1 })));
								}
								dispatch(handleAnswerCalling(false));
							} else {
								dispatch(
									updateQuestion({
										id: uniqueId,
										question: suggestion,
										answer: result.message,
										isTyping: "Done",
										is_file: result.is_file,
										productType: "product_search"
									})
								);

								// Filter out duplicates before adding
								const filteredNewProducts = newProducts.filter(
									(newProd: any) => !cartProducts.some((existingProd: any) => existingProd.variant_id === newProd.variant_id)
								);

								setCartsProduct([...cartProducts, ...filteredNewProducts]);
								const finalArray = [...cartProducts, ...filteredNewProducts]
								localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(finalArray))
								// Mirror bulk add to Shopify cart
								postAddToShopifyCart(filteredNewProducts.map((p: any) => ({ variant_id: p.variant_id, quantity: 1 })));
								dispatch(handleAnswerCalling(false));
							}
						} else {
							dispatch(setSuggestionList(result.suggested_questions))
							if (localStorage.getItem("clientName") !== "InzaloEMS") {
								if(ishandleModeDetails === 'voice' || ishandleModeDetails === 'hybrid'){
								await handleSpeak(result?.response, uniqueId)
								}
								dispatch(
									updateQuestion({
										id: uniqueId,
										question: suggestion,
										answer: result,
										isTyping: "Done",
										is_file: result.is_file,
										productType: "product_search"
									})
								);
								dispatch(handleAnswerCalling(false));
							} else {
								if(ishandleModeDetails === 'voice' || ishandleModeDetails === 'hybrid'){
								await handleSpeak(result?.response, uniqueId)
								}
								dispatch(
									updateQuestion({
										id: uniqueId,
										question: suggestion,
										answer: result,
										isTyping: "Done",
										is_file: result.is_file,
										productType: "product_search"
									})
								);
								dispatch(handleAnswerCalling(false));

							}
						}
					}

				} catch (error: any) {
					dispatch(setSuggestionList([]));
					if (error === "Need to login") {
						dispatch(handleBotLoginQue(suggestion))
						dispatch(
							updateQuestion({
								id: uniqueId,
								question: suggestion,
								answer: "Please provide me your Email Id!",
								isTyping: "Done",
								productType: "product_search"
							})
						);
						dispatch(handleAnswerCalling(false));
						setError(true);
					} else {
						// Handle other errors
						dispatch(
							updateQuestion({
								id: uniqueId,
								question: suggestion,
								answer: error,
								isTyping: "Done",
								productType: "product_search"
							})
						);
						dispatch(handleAnswerCalling(false));
					}
					return {};
				}
			}
		}
		// }



	}

	const getStyledRecommendations = async (product: Product) => {
		// dispatch(handBotleLoader(true));
		setActiveIndexStyledProduct(0);
		const depCustomer = await decryptAesGcmB64(JSON.parse(localStorage.getItem("username") as any), KEY_B64);
		const depCustomerParse = JSON.parse(depCustomer);
		const data = {
			product_id: product?.variant_id,
			user_name: depCustomerParse.email,
		}
		try {
			const { result, error } = await getRecommendationsStyleIdeas(data);
			if (error) {
				throw error
			}
			if (result?.error) {
				throw result.error
			}
			setStyledIdeaProducts(result.results)
			// dispatch(handBotleLoader(false));
		} catch (error: any) {
			toast.error(error, {
				style: {
					backgroundColor: '#F1F1F1', // Grey background
				}
			})
			if (error === 'something went wrong') {
				setStyledIdeaProducts('something went wrong')
			}
			dispatch(handBotleLoader(false));
		}
	}

	const getBundlingSuggestion = async (product: Product) => {
		// dispatch(handBotleLoader(true));
		setActiveIndexBundleProduct(0)
		const depCustomer = await decryptAesGcmB64(JSON.parse(localStorage.getItem("username") as any), KEY_B64);
		const depCustomerParse = JSON.parse(depCustomer);
		const data = {
			product_id: product?.variant_id,
			user_name: depCustomerParse.email,
		}
		try {
			const { result, error } = await bundlingSuggestion(data);
			if (error) {
				throw error
			}
			if (result?.error) {
				throw result.error
			}
			// setBundlingSuggestionProducts(result)
			setBundlingSuggestionProducts(result.results)
			// dispatch(handBotleLoader(false));
		} catch (error: any) {
			toast.error(error, {
				style: {
					backgroundColor: '#F1F1F1', // Grey background
				}
			})
			dispatch(handBotleLoader(false));
		}
	}

	const customStyleAndBundling = async (product: Product) => {
		setBundlingSuggestionProducts([]);
		setStyledIdeaProducts([]);
		dispatch(handBotleLoader(true));
		await getStyledRecommendations(product)
		await getBundlingSuggestion(product)
		dispatch(handBotleLoader(false));
	}

	const hanldeProductDetail = (product: Product, products: Product[]) => {
		setProductList(products)
		setSingleProduct(product)
		// customStyleAndBundling(product)
	}
	// Function to get the active product

	useEffect(() => {
		if (productCompareList?.length > 0) {
			setAddedCompare("Added to Compare")
		}

		setTimeout(() => {
			setAddedCompare("")
		}, 2000)
	}, [productCompareList])
	const comparisonColumn = (list: Product[]) => {
		return list.map((li: Product, index: number) => {
			if (index < 3) {
				return (
					<div className="compare-col" key={index}>
						<div className="compare-top">
							{list?.length > 1 &&
								<i className="remove-product" onClick={() => removeProductFromCompareList(li.variant_id)}><img src={cancelIcon} alt="close" /></i>
							}
							<figure>
								<img src={li.variant_image} alt={li.title} />
							</figure>
							<div className="pro-sm-info">
								<p>{li.title}</p>
								<strong>${li.price}</strong>
								<div className="pro-review"><i><img src={StarFill} alt="StarFill" /></i>{li.rating}</div>
								<p>Delivery By Tomorrow <span className="green-txt">Free</span></p>
							</div>
						</div>
						<div className="pro-seprator">
							Highlights
						</div>
						<div className="compare-bottom">
							<p>128 GB ROM</p>
							<p>15.49 cm (6.1 inch) Super Retina XDR Display</p>
							<p>48MP + 12MP Dual Rear Camera</p>
							<p>12MP Front Camera</p>
							<p>A16 Bionic Chip, 6 Core Processor Hexa Core</p>
							<p>iOS 17</p>
							<p>1 Year Warranty for Phone and 6 months warranty for In-box</p>
						</div>
					</div>
				)
			}
		})

	}
	const removeProductFromCompareList = (nameToRemove: string) => {
		const newData = productCompareList.filter((item: any) => item.variant_id !== nameToRemove)
		setProductCompareList(newData);
	};
	const removeCheckedProducts = () => {
		const updatedProducts = productCompareList.filter(
			(product: any) => !checked.some(
				(removeProduct: string) => removeProduct === product.variant_id
			)
		);
		setProductCompareList(updatedProducts);
		setToggleAddProducts(false);
		if (checked?.length === 3) {
			setCurrentActivePage("detail")
		}
		setChecked([])
	}
	const handlePageChange = (e: any) => {
		if (e.page < productList?.length && e.page > -1) {
			const selectedProduct = productList[e.page];
			setSingleProduct(selectedProduct);
			setActiveIndex(e.page);
			dispatch(resetProductPageQuestion());
			setBundlingSuggestionProducts([]);
			setStyledIdeaProducts([]);
			setAddToCartBtnName("Add to Cart");

			if (selectedProduct.variant_id !== lastProductId) {
				setLastProductId(selectedProduct.variant_id);
				// customStyleAndBundling(selectedProduct);
			}
		}
	};
	const handleBundleProductClick = async (product: Product) => {
		dispatch(handBotleLoader(true));
		dispatch(resetProductPageQuestion());
		setAddToCartBtnName("Add to Cart");
		setActiveIndexStyledProduct(0)
		if (productDetailPageRef.current) {
			productDetailPageRef.current.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}
		setProductList([product])
		setSingleProduct(product)
		const matchedIndex = ([product]).findIndex(
			(item: any) => item.variant_id === product.variant_id
		);

		if (matchedIndex !== -1) {
			setActiveIndex(matchedIndex);
		} else {
			setActiveIndex(activeIndex);
		}
		if (product.variant_id !== lastProductId) {
			setLastProductId(product.variant_id);
			// customStyleAndBundling(product);
		}
	}
	const BundlingItem = (product: Product) => {
		return (
			<div className={`product-card`} id={product.variant_id}>
				<div className="product-card-wrap" onClick={() => handleBundleProductClick(product)}>
					<figure>
						<span><ImageWithFallback src={product.variant_image !== null ? product.variant_image : defaultImg} fallbackSrc={defaultImg} alt={product.title} /></span>
						<figcaption><p title={product.title}>{product.title?.length > 20 ? `${product.title.slice(0, 20)}...` : product.title}</p><i><img src={LinkIconWhite} alt="link-icon" /></i></figcaption>
					</figure>
				</div>
			</div>
		)
	}

	const handleStyledProductClick = async (product: Product) => {
		dispatch(handBotleLoader(true));
		dispatch(resetProductPageQuestion());
		setAddToCartBtnName("Add to Cart");
		setActiveIndexStyledProduct(0)
		if (productDetailPageRef.current) {
			productDetailPageRef.current.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}
		setProductList([product])
		setSingleProduct(product)
		const matchedIndex = ([product]).findIndex(
			(item: any) => item.variant_id === product.variant_id
		);

		if (matchedIndex !== -1) {
			setActiveIndex(matchedIndex);
		} else {
			setActiveIndex(activeIndex);
		}
		if (product.variant_id !== lastProductId) {
			setLastProductId(product.variant_id);
			// customStyleAndBundling(product);
		}
	}

	const ItemTemplate = React.memo(({ productGroup, singleProduct }: any) => (
		<div className="style-recommendation">
			<div className="product-top">
				<figure>
					<ImageWithFallback
						src={singleProduct?.variant_image !== null ? singleProduct?.variant_image : defaultImg}
						alt={singleProduct?.title}
						fallbackSrc={defaultImg}
						styles={{ width: '100%', height: 'auto' }}
					/>
				</figure>
			</div>
			<div className="recommendation-section">
				{productGroup?.map((product: Product, index: number) => (
					<div key={index} className="single-recommendation" onClick={() => handleStyledProductClick(product)}>
						<figure>
							<ImageWithFallback
								src={product?.variant_image !== null ? product?.variant_image : defaultImg}
								alt={product?.title}
								fallbackSrc={defaultImg}
								styles={{ width: '60px', height: '60px' }}
							/>
						</figure>
						<p title={product.title}>{product.title}</p>
						<h6>${product.price}</h6>
					</div>
				))}
			</div>
		</div>
	));

	const carouselComponent = useMemo(() => {
		return (
			<div className="style-recommendation-container">
				<Carousel
					page={activeIndexStyledProduct}
					onPageChange={(e) => setActiveIndexStyledProduct(e.page)}
					value={chunkedStyledIdeaProducts}
					numScroll={1}
					numVisible={1}
					responsiveOptions={[]}
					showNavigators={false}
					showIndicators={styledIdeaProducts?.length > 3}
					itemTemplate={(productGroup: Product[]) => (
						<ItemTemplate productGroup={productGroup} singleProduct={singleProduct} />
					)}
				/>
			</div>
		);
	}, [styledIdeaProducts,
		// chunkedStyledIdeaProducts,
		activeIndexStyledProduct,
		singleProduct,
	]); // Only recomputes when styledIdeaProducts changes

	const handleAddToCart = (newProduct: any) => {
		if (!cartProducts.some((product: any) => product.variant_id === newProduct.variant_id)) {
			setCartsProduct([...cartProducts, newProduct]);
			const finalArray = [...cartProducts, newProduct]
			localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(finalArray))
			// Mirror add to Shopify cart
			postAddToShopifyCart([{ variant_id: newProduct.variant_id, quantity: 1 }]);
		} else {
			setCartPageVisible(true)
			setProductCartList([])
		}
	}
	const formatUSD = (value: number) =>
		new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
		}).format(value);
	// const formatUSD = (value: number) =>
	//     new Intl.NumberFormat('en-IN', {
	//         style: 'currency',
	//         currency: 'INR',
	//     }).format(value);

	const productDetailPage = () => {
		const addToCompare = () => {
			if (productCompareList?.length === 0) {
				const tempProduct = productList[activeIndex]
				setProductCompareList([tempProduct])
			} else {
				setCurrentActivePage("compare")
			}
		}
		// const handleAddToCart = (product: any) => {
		//     // setAddToCart("Thanks for adding the product to the demo cart!");
		//     // setAddToCartBtnName("Added to Cart")
		//     // setTimeout(() => {
		//     //     setAddToCart("")
		//     // }, 2000)
		//     setProductList([]);
		//     setProductCompareList([]);
		//     setActiveIndexBundleProduct(0);
		//     setActiveIndexStyledProduct(0);
		//     setAddToCartBtnName("Add to Cart");
		//     dispatch(resetProductPageQuestion());
		//     dispatch(addOrRemoveObjectForAddToCart(product));
		//     const uniqueId = uuidv4();
		//     const uniqueId2 = uuidv4();
		//     dispatch(
		//         addQuestion({ id: uniqueId, question: "", answer: `We have added the ${product.title} to your cart.`, isTyping: "Done", isCsv: "", productType: "product_search" })
		//     );
		//     setTimeout(() => {
		//         dispatch(
		//             addQuestion({ id: uniqueId2, question: "", answer: `Based on your preference for the ${product?.title}, you might be interested in exploring related products. Would you like to view them?`, isTyping: "Done", isCsv: "", productType: "product_search" })
		//         );
		//     }, 1000)
		// }
		const updatedProducts = productList?.filter(
			(product: any) => !productCompareList.some(
				(removeProduct: Product) => removeProduct.variant_id === product.variant_id
			)
		);
		const handleChecked = (link: string) => {
			if (checked.includes(link)) {
				setChecked(checked.filter((ch: string) => ch !== link))
			} else {
				setChecked([...checked, link])
			}
		}
		return (<>
			{(productList?.length > 0 || productCartList.length > 0) &&
				<>
					{currentActivePage === 'detail' ?
						<div className={`product-detail-wrap`} style={{ zIndex: "100" }}>
							<div className="product-details" ref={productDetailPageRef}>
								<i className="close-product" onClick={() => {
									if (productCartList.length === 0) {
										setProductList([]);
										setProductCompareList([]);
										setActiveIndexBundleProduct(0);
										setActiveIndexStyledProduct(0);
										scrollToBottom();
										setAddToCartBtnName("Add to Cart");
										dispatch(resetProductPageQuestion());
									} else {
										dispatch(resetProductPageQuestion());
										setCartPageVisible(true);
										setProductCartList([]);
									}
								}}><img src={CloseIcon} alt="close" /></i>
								{productCartList.length === 0 ?
									<Carousel page={activeIndex} showIndicators={false} showNavigators={productList?.length > 1 ? true : false} value={productList} onPageChange={handlePageChange} numScroll={1} numVisible={1} itemTemplate={productDetailTemplate} />
									: <Carousel page={0} showIndicators={false} showNavigators={productCartList.length > 1 ? true : false} value={productCartList} onPageChange={handlePageChange} numScroll={1} numVisible={1} itemTemplate={productDetailTemplate} />
								}
								{/* <div className="product-top">
                    <figure>
                        <img src={obj.product.link} alt={obj.product.title} />
                    </figure>
                </div> */}
								{productList?.length > 0 && productCartList.length === 0 &&
									<div className="product-bottom">
										{/* <div className="product-name">Apple iPhone 16 (Ultramarine, 128 GB)</div> */}
										<div className="product-name">{productList[activeIndex]?.title !== null ? productList[activeIndex]?.title : "N/A"}</div>
										{/* <strong>${productList[activeIndex]?.price !== null ? productList[activeIndex]?.price : ""}</strong> */}
										<strong>{productList[activeIndex]?.price !== null ? formatUSD(productList[activeIndex]?.price) : ""}</strong>
										{/* Ratting starts  */}
										{/* <div className="star-review d-flex align-items-center">
                                            {renderStars(parseFloat(productList[activeIndex]?.rating))}
                                            <span className="rating ml-1">{productList[activeIndex]?.rating}</span>
                                            <a href="javascript:void(0)" style={{ cursor: "default" }} className="review-rating">{productList[activeIndex]?.no_of_rating} Ratings</a>
                                        </div> */}
										<div className="product-list-details">
											{/* <li><p>Color: <b>{productList[activeIndex]?.baseColour}</b></p></li> */}
											{/* <li><p>Storage: <b>128 GB</b></p></li> */}
											<li><p><b>Description</b>: {productList[activeIndex]?.description !== null ? productList[activeIndex]?.description : "N/A"}</p></li>
										</div>
									</div>
								}
								{productCartList?.length > 0 &&
									<div className="product-bottom">
										{/* <div className="product-name">Apple iPhone 16 (Ultramarine, 128 GB)</div> */}
										<div className="product-name">{productCartList[0]?.title !== null ? productCartList[0]?.title : "N/A"}</div>
										{/* <strong>${productCartList[0]?.price !== null ? productCartList[0]?.price : ""}</strong> */}
										<strong>{productCartList[0]?.price !== null ? formatUSD(productCartList[0]?.price) : ""}</strong>
										{/* <div className="star-review d-flex align-items-center">
                                            {renderStars(parseFloat(productCartList[0]?.rating))}
                                            <span className="rating ml-1">{productCartList[0]?.rating}</span>
                                            <a href="javascript:void(0)" style={{ cursor: "default" }} className="review-rating">{productCartList[0]?.no_of_rating} Ratings</a>
                                        </div> */}
										<div className="product-list-details">
											<li><p><b>Description</b>: {productCartList[0]?.description !== null ? productCartList[0]?.description : "N/A"}</p></li>
										</div>
									</div>
								}
								{addedCompare !== '' && <span className="compare-toast">{addedCompare}</span>}
								{addToCart !== '' && <span className={`compare-toast large-box ${(productList[activeIndex]?.details === null) ? "compare-toast-empty-description" : ""}`}>{addToCart}</span>}
								<ul className="pro-action-btn d-flex justify-content-center">
									{/* <li style={{ pointerEvents: "none", opacity: "0.5" }}>
                                        <button className="outline-btn" style={{ border: "none", background: "#e1e1e1" }} onClick={addToCompare}>{productCompareList?.length === 0 ? "Add" : "Go"} to Compare</button>
                                    </li> */}
									<li>
										{productList?.length > 0 && productCartList.length === 0 ?
											<button type="button" className={`outline-active-btn ${(addToCartBtnName === "Added to Cart") ? "active-cart-btn" : ""}`} onClick={() => handleAddToCart(productList[activeIndex])}>{cartProducts.some((product: any) => product?.variant_id === productList[activeIndex]?.variant_id) ? 'Go' : 'Add'} to Cart</button>
											: <button type="button" className={`outline-active-btn ${(addToCartBtnName === "Added to Cart") ? "active-cart-btn" : ""}`} onClick={() => handleAddToCart(productCartList[0])}>Go to Cart</button>
										}
									</li>
								</ul>
								{/* {styledIdeaProducts !== "No Style idea found" && styledIdeaProducts !== 'something went wrong' &&
                                    <div className="style-section">
                                        <h3>Style Picks for You</h3>
                                        {carouselComponent}
                                    </div>
                                } */}
								{/* <div className="style-section">
                                    <h3>Frequently Bought Together</h3>
                                    <div className={`product-slider-wrap`}>
                                        <div className="product-slider bundle">
                                            <Carousel page={activeIndexBundleProduct} className="clg"
                                                onPageChange={(e) => setActiveIndexBundleProduct(e.page)} value={bundlingSuggestionProducts} numScroll={1} showNavigators={bundlingSuggestionProducts?.length > 3 ? true : false} numVisible={3} responsiveOptions={responsiveOptions} itemTemplate={BundlingItem} />
                                        </div>
                                    </div>
                                </div> */}
								<div className="product-details-chat">
									{productPageMessages && productPageMessages?.map((obj: any, index: number) => {
										return (
											<>
												{obj.question && <div className={`input-message-container visible opacity-100`} >
													<p style={{ background: data?.bot_config?.question_background_colour, fontSize: `${fontSize1}px` }}>{obj.question}</p>
												</div>}
												{obj.isTyping === "Typing"
													? <div className={`output-message-container visible opacity-100`}>
														<p style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>
															<span className="jumping-dots">
																<span className="dot-1"></span>
																<span className="dot-2"></span>
																<span className="dot-3"></span>
															</span>
														</p>
													</div>
													: <div className={`output-message-container visible opacity-100`}>
														{/* {(ishandleModeDetails && (ishandleModeDetails === 'text' || ishandleModeDetails === 'hybrid')) && ( */}
															<p style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>{MarkdownRenderer(obj.answer)}</p>
														{/* )} */}
													</div>
												}
											</>
										);
									})}
								</div>
								<span ref={productPageChatRef}></span>
							</div>
						</div>
						:
						<div className="product-detail-wrap">
							<div className="product-details">
								<div className="compare-head">
									<h5>Compare</h5>
									<span className="compare-head-right">
										<i className="add-product" onClick={() => setToggleAddProducts(true)}><img src={ProductAdd} alt="ProductAdd" /></i>
										<i><img src={CloseIcon} alt="close" onClick={() => setCurrentActivePage("detail")} /></i>
									</span>
								</div>
								<div className={`compare-product ${productCompareList?.length === 3 ? 'three-col' : ''}`}>

									{comparisonColumn(productCompareList)}
									{productCompareList?.length < 2 &&
										<div className="compare-col add-new-product">
											<div className="compare-top">
												{/* <i className="remove-product"><img src={cancelIcon} alt="close" /></i> */}
												<div className="placeholder-img"></div>
												<div className="pro-sm-info">
													<div className="btn-area">
														<button className="outline-active-btn" onClick={() => setToggleAddProducts(true)}>Add a Product</button>
													</div>
													<p>NA</p>
												</div>
											</div>
											<div className="pro-seprator">
												Highlights
											</div>
											<div className="compare-bottom">
												<p>Storage</p>
												<p>Screen Size/ Resolution</p>
												<p>Rear Camera</p>
												<p>Front Camera</p>
												<p>Processor</p>
												<p>OS</p>
												<p>Warranty</p>
											</div>
										</div>
									}
								</div>
							</div>
						</div>
					}
					{toggleAddProducts && currentActivePage === 'compare' && productCompareList?.length < 3 &&
						<div className="product-detail-wrap remove-product similar-product">
							<div className="product-details">
								<div className="product-heading">
									<h5>Similar Product to Compare</h5>
									<i className="close-product"><img src={CloseIcon} onClick={() => { setToggleAddProducts(false); setAddToCartBtnName("Add to Cart"); }} alt="close" /></i>
								</div>
								<div className="product-listing">
									{updatedProducts.map((product: Product, index: number) => (
										<div key={index} className="product-listing-wrap" onClick={() => { setProductCompareList([...productCompareList, product]); setToggleAddProducts(false) }}>
											<div className="product-right">
												<figure>
													<img src={product?.variant_image} alt={product?.title} />
												</figure>
												<div className="pro-sm-info">
													<p>{product?.title}</p>
													{/* <p>Apple iPhone 16 (Ultramarine, 128 GB)</p> */}
													<strong>${product?.price}</strong>
													<div className="pro-review"><i><img src={StarFill} alt="StarFill" /></i>4</div>
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					}
					{toggleAddProducts && currentActivePage === 'compare' && productCompareList?.length === 3 &&
						<div className="product-detail-wrap remove-product">
							<div className="product-details">
								<div className="product-heading">
									<h5>Remove one Product to Compare</h5>
									<i className="close-product" onClick={() => { setToggleAddProducts(false); setChecked([]); setAddToCartBtnName("Add to Cart"); }}><img src={CloseIcon} alt="close" /></i>
								</div>
								<div className="product-listing">
									{productCompareList.map((product: Product, index: number) => (
										<div className="product-listing-wrap" key={index}>
											<div className="product-checkbox">
												<Checkbox checked={checked.includes(product.variant_id) ? true : false} onChange={() => handleChecked(product.variant_id)}></Checkbox>
											</div>
											<div className="product-right">
												<figure>
													<img src={product.variant_image} alt={product.title} />
												</figure>
												<div className="pro-sm-info">
													<p>{product.title}</p>
													{/* <p>Apple iPhone 16 (Ultramarine, 128 GB)</p> */}
													<strong>${product.price}</strong>
													<div className="pro-review"><i><img src={StarFill} alt="StarFill" /></i>4</div>
												</div>
											</div>
										</div>
									))}
								</div>
								<ul className="pro-action-btn">
									<li>
										<button className="outline-btn" onClick={() => { setChecked([]); setToggleAddProducts(false) }}>Cancel</button>
									</li>
									<li>
										<button onClick={removeCheckedProducts} style={{ opacity: checked?.length === 0 ? "0.5" : "1", pointerEvents: checked?.length === 0 ? "none" : "visible" }} className="outline-active-btn">Remove</button>
									</li>
								</ul>
							</div>
						</div>
					}
				</>
			}
		</>)
	}
	const handleResponse = (obj: any) => {
		// if (obj.productType === "product_recommendation" && obj.products) {
		//     const tempProducts = obj.products
		//     return <>
		//         <div className={`output-message-container ${productList?.length > 0 || productCartList.length > 0 ? 'invisible opacity-0' : 'visible opacity-100'}`}>
		//             <p style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>{MarkdownRenderer(obj.answer)}</p>
		//         </div>
		//         <div className={`product-slider-wrap ${productList?.length > 0 || productCartList.length > 0 ? 'invisible opacity-0' : 'visible opacity-100'}`}>
		//             <div className="product-slider">
		//                 <Carousel value={obj.products} numScroll={1} showNavigators={obj.products?.length > 3 ? true : false} numVisible={3} responsiveOptions={responsiveOptions} itemTemplate={(product: any) => productTemplate(product, obj.products)} />
		//             </div>
		//         </div>
		//     </>
		//     // return <Carousel value={obj.products} numScroll={1} numVisible={3} responsiveOptions={responsiveOptions} itemTemplate={productTemplate} />
		// } else {
		//     // if (obj.productType === "product_search" && obj.answer) {
		//     return <div className={`output-message-container ${productList?.length > 0 || productCartList.length > 0 ? 'invisible opacity-0' : 'visible opacity-100'}`}>
		//         <p style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>{obj.is_file ? <span>Here is the link to the CSV file:  <Link to="" onClick={() => handleDownloadPdf(obj.answer, obj.file_type)}>Reference Data</Link></span> : MarkdownRenderer(obj.answer)}</p>
		//     </div>
		// }
		return <>
			<div className={`output-message-container ${productList?.length > 0 || productCartList.length > 0 ? 'invisible opacity-0' : 'visible opacity-100'}`}>
				{/* {
                    !_.isEmpty(data?.bot_config?.bot_logo)
                        ? <div><span className="chat-img"><img src={`data:image/png;base64,${data?.bot_config?.bot_logo}`} alt="bot-logo" className="bot-logo" /></span></div>
                        : <div><span className="chat-img"><img src={logoOFBot} alt="bot-logo" className="bot-logo" /></span></div>
                } */}
				{/* {(ishandleModeDetails && (ishandleModeDetails === 'text' || ishandleModeDetails === 'hybrid')) && ( */}
				<p style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						{obj?.answer?.visualization !== null && <h4 style={{ display: "flex", fontSize: "22px", alignItems: "center" }}><i style={{ height: "30px", width: "30px", borderRadius: "50%", display: "flex", border: "1px solid #5627d9", marginRight: "10px" }}><svg width="28" height="28" viewBox="0 0 24 24" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<defs>
								<linearGradient id="sparkleGradient" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
									<stop stopColor="#6C63FF" />
									<stop offset="1" stopColor="#8B85FF" />
								</linearGradient>
							</defs>

							<path d="M12 7L13 10L16 11L13 12L12 15L11 12L8 11L11 10L12 7Z"
								stroke="url(#sparkleGradient)"
								stroke-width="1.6"
								stroke-linecap="round"
								stroke-linejoin="round" />

							<circle cx="17.5" cy="7.5" r="1.2"
								fill="url(#sparkleGradient)" />

							<circle cx="7" cy="15.5" r="1"
								fill="url(#sparkleGradient)" />
						</svg>
						</i>AI Insights</h4>}
						{(ishandleModeDetails && (ishandleModeDetails === 'voice' || ishandleModeDetails === 'hybrid')) && (() => {
							// Use obj.id as primary, fallback to obj.message_id for backward compatibility
							const messageId = obj?.id || obj?.message_id;
							if (!messageId) {
								// Skip rendering speaker icon if no valid ID found
								return null;
							}
							
							// Check if response is still loading (API hasn't returned yet)
							const isResponseLoading = obj?.isTyping === "Typing";
							
							// Check if any other message has audio preparing
							const isOtherAudioPreparing = Object.entries(ttsStatusById).some(
								([otherId, status]) => 
									otherId !== messageId && 
									status === 'preparing'
							);
							
							// Check if another message audio is currently playing
							const isOtherAudioPlaying = stopId && 
								stopId !== messageId && 
								stopId !== '' && 
								stopId !== null &&
								ttsStatusById[stopId] === 'playing';
							
							const isPreparingCurrent = ttsStatusById[messageId] === 'preparing';
							
							// Disable if: response is loading, current is preparing, or other is preparing/playing
							const isDisabled = isResponseLoading || isPreparingCurrent || isOtherAudioPreparing || isOtherAudioPlaying;
							
							return (
								<span
									className='conversation-section-icon-top'
									onClick={(e) => {
										e.stopPropagation();
										
										// Prevent clicks if disabled
										if (isDisabled) {
											return;
										}
										
										handleSpeak(
											obj?.answer?.response, messageId
										);
									}}
									style={(() => {
										if (stopId === messageId) {
											return {
												backgroundColor: '#F1F1F1',
												border: '1px solid #404040',
												borderRadius: '50%',
												float: 'right',
												cursor: 'pointer',
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center',
												height: '25px',
												width: '25px'
											};
										} else if (isDisabled) {
											// Disabled state: response loading, preparing, or other audio active
											return {
												float: 'right',
												cursor: 'not-allowed',
												opacity: 0.4,
												display: 'flex',
												alignItems: 'center',
												gap: '4px',
												pointerEvents: 'none' as const,
											};
										} else {
											return {
												float: 'right',
												cursor: 'pointer',
												display: 'flex',
												alignItems: 'center',
												gap: '4px',
											};
										}
									})()}
								>
									<img
										id={`speaker-${messageId}`}
										data-message-id={messageId}
										data-tooltip-id={`tts-tooltip-${messageId}`}
										data-tooltip-content={
											isResponseLoading
												? 'Waiting for response...'
												: ttsStatusById[messageId] === 'preparing'
													? 'Preparing audio...'
													: ttsStatusById[messageId] === 'playing'
														? 'Playing audio'
														: isOtherAudioPreparing
															? 'Another audio is preparing...'
															: 'Text-to-Speech'
										}
										title={
											isResponseLoading
												? 'Waiting for response...'
												: ttsStatusById[messageId] === 'preparing'
													? 'Preparing audio...'
													: ttsStatusById[messageId] === 'playing'
														? 'Playing audio'
														: isOtherAudioPreparing
															? 'Another audio is preparing...'
															: 'Text to Speech'
										}
										className='speaker-button'
										src={speakerIcon}
										alt='speaker-button'
									/>
									{isResponseLoading && (
										<span style={{ fontSize: '11px', color: '#666' }}>Loading...</span>
									)}
									{!isResponseLoading && ttsStatusById[messageId] === 'preparing' && (
										<span style={{ fontSize: '11px', color: '#666' }}>Preparing...</span>
									)}
								</span>
							);
						})()}
					</div>
					{MarkdownRenderer(obj?.answer?.response)}
				</p>
				{/* )} */}
				
			</div >
			<div className="chart-table-wrapper">
				{obj.answer.visualization !== null &&
					<ChartWrapper plotJson={obj?.answer?.visualization?.data} />
				}
				{typeof obj.answer.results === "string" &&
					obj.answer.results.trim() !== "" &&
					<DynamicTable dataString={obj.answer.results} />
				}
			</div>
		</>
	}

	const scrollToBottom = () => {
		// messagesEndRef?.current?.scrollTo({
		//     top: messagesEndRef?.current.scrollHeight,
		//     left: 0,
		//     behavior: 'smooth',
		// })
		if (messagesEndRef.current) {
			messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	}
	// useEffect(() => {
	//     if (userHandler === undefined) {
	//         dispatch(handleIsUserHandler(false));
	//     }
	// }, [userHandler])

	// useEffect(() => {
	//     if (userHandler !== undefined) {
	//         const timer = setTimeout(() => {
	//             setShowSuggestions(true);
	//         }, 2000); // 2 seconds delay

	//         return () => clearTimeout(timer); // cleanup on unmount
	//     }
	//     if (!isUserHandler && userHandler !== undefined && suggestionList?.length === 0) {
	//         setShowSuggestions(true);
	//     }
	// }, [userHandler]);

	const handleRefresh = async () => {
		setShowSuggestions(false)
		if (userHandler !== undefined) {
			dispatch(handleIsUserHandler(true));
		} else {
			dispatch(handleIsUserHandler(false));
		}
		dispatch(resetProductPageQuestion())
		dispatch(setSuggestionList([]));
		dispatch(setIsNewConversation("new"))
		dispatch(resetQuestion())
		setTypePassword(false)
		setFollowUP(false);
		setTest("");
		setChatToken("");
		// dispatch(controlHandlerState(""));
		setBotProduct("")
		setProductCompareList([])
		setProductList([]);
		setToggleAddProducts(false);
		setChecked([]);
		setCurrentActivePage("detail")
		setLinkIconHover2(LinkIcon);
		setLinkIconHover1(LinkIcon);
		setError(false);
		setMessage("")
		localStorage.removeItem("wrongAttempt");
		localStorage.removeItem("attempt");
		localStorage.removeItem("false_attempt");
		// try {
		//     const { result, error } = await memoryClear();
		//     if (error) {
		//         throw error
		//     }
		//     if (result?.error) {
		//         throw result.error
		//     }
		localStorage.removeItem("username");
		localStorage.removeItem("chat_access_token");
		localStorage.removeItem("botId");
		// toast.success(result.message)
		// } catch (error: any) {
		//     toast.error(error, {
		//         style: {
		//             backgroundColor: '#F1F1F1', // Grey background
		//         }
		//     })
		// }
	}

	const handleBotData = async () => {
		dispatch(handBotleLoader(true));
		let Client: string | null = "hof"
		// const env = localStorage.getItem("clientName")
		// if (window.location.origin === 'https://ron.rysun.in:3001' && env === "ron_prod") {
		//     Client = "frida_prod"
		// } else if (window.location.origin !== 'https://ron.rysun.in:3001' && env === "ron_stage") {
		//     Client = "frida"
		// } else {
		//     Client = env
		// }
		try {
			const { result, error } = await getBotConfigurations(Client);
			if (error) {
				throw error
			}
			if (result?.error) {
				throw result.error
			}
			setData(result);
			setBotl(`data:image/png;base64,${result.bot_config.bot_logo}`)
			setAvtarl(`data:image/png;base64,${result.bot_config.avatar_logo}`)
			setFontSize1(result.bot_config.font_size)
			dispatch(handBotleLoader(false));
		} catch (error: any) {
			dispatch(handBotleLoader(false));
			toast.error(error, {
				style: {
					backgroundColor: '#F1F1F1', // Grey background
				}
			});
			return {};
		}
	}

	useEffect(() => {
		scrollToBottom();
		setAddToCartBtnName("Add to Cart")
	}, [messages, showSuggestions]);

	const scrollOne = () => {
		if (productPageChatRef.current) {
			productPageChatRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	}
	useEffect(() => {
		if (productPageMessages?.length > 0) {
			scrollOne()
		}
	}, [productPageMessages])

	useEffect(() => {
		// On initial mount, ensure no stale audio is playing (defensive)
		stopTTSPlayback(false);
	}, [])

	useEffect(() => {
		if (message !== "") {
			inputRef?.current?.focus();
		}
		if (message === "Listening...") {
			inputRef.current.blur();
		}
	}, [message])

	const MarkdownRenderer = (content: any) => {
		if (!content || content === null || content === undefined) {
			return null;
		}

		// Handle encrypted payload objects
		if (typeof content === 'object' && content.iv && content.ct) {
			return null; // Don't render encrypted objects
		}

		// Ensure content is a string
		const stringContent = typeof content === 'string' ? content : String(content);

		return (
			<ReactMarkdown
				components={{
					// Paragraphs
					p: ({ node, ...props }) => <p className={styles['markdown-paragraph']} {...props} />,

					// p: ({ children, ...props }) => {
					//     const lines = children[0]?.toString()?.split('\n') || [];

					//     let isFirstLine = true;
					//     const transformedLines = lines.map((line) => {
					//         const trimmedLine = line.trim();
					//         const isDotPresent = trimmedLine.includes('•');
					//         const hasTextBeforeDot = isDotPresent && trimmedLine.indexOf('•') > 0;

					//         const shouldBreakLine = hasTextBeforeDot && !isFirstLine;

					//         isFirstLine = false;
					//         return shouldBreakLine ? '<br>•' + trimmedLine : line;
					//     });

					//     let transformedContent = transformedLines.join('<br>');
					//     transformedContent = transformedContent.replace(/"([^"]*)"/g, '<b>$1</b>');
					//     transformedContent = transformedContent.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
					//     return (
					//         <p
					//             className={styles['markdown-paragraph']}
					//             dangerouslySetInnerHTML={{ __html: transformedContent }}
					//             {...props}
					//         />
					//     );
					// },
					//  Headings
					h1: ({ node, ...props }) => (
						<h1
							className={styles['markdown-heading1']}
							{...props}
						/>
					),
					h2: ({ node, ...props }) => (
						<h2
							className={styles['markdown-heading2']}
							{...props}
						/>
					),
					h3: ({ node, ...props }) => (
						<h3
							className={styles['markdown-heading3']}
							{...props}
						/>
					),
					h4: ({ node, ...props }) => (
						<h4
							className={styles['markdown-heading4']}
							{...props}
						/>
					),
					h5: ({ node, ...props }) => (
						<h5
							className={styles['markdown-heading5']}
							{...props}
						/>
					),
					h6: ({ node, ...props }) => (
						<h6
							className={styles['markdown-heading6']}
							{...props}
						/>
					),

					// Lists
					ul: ({ node, ...props }) => (
						<ul
							className={styles['markdown-unordered-list']}
							{...props}
						/>
					),
					ol: ({ node, ...props }) => (
						<ol
							className={styles['markdown-ordered-list']}
							{...props}
						/>
					),

					// List Items
					li: ({ node, ...props }) => (
						<li
							className={styles['markdown-list-item']}
							{...props}
						/>
					),

					// Links
					a: ({ node, ...props }: any) => (
						<a
							className={styles['markdown-link']}
							href={node.href}
							{...props}
							target="_blank"
						>
							{props.children}
						</a>
					),
					strong: ({ node, ...props }) => (
						<strong
							className={styles['markdown-strong']}
							{...props}
						/>
					),
					// Custom renderer for bold text
					// bold: ({ node, ...props }:any) => (
					//     <b className={styles['markdown-bold']}
					//         {...props}
					//     />
					// ),
					// Code Blocks styling or auto formatting API response...
					pre: ({ node, ...props }) => (
						<pre
							className={styles['markdown-code-block']}
							{...props}
						/>
					),
					// code: ({ inline, node, ...props }) => {
					//     if (inline) {
					//         return (
					//             <code
					//                 className={styles['markdown-inline-code']}
					//                 {...props}
					//             />
					//         );
					//     }
					//     return (
					//         //     <SyntaxHighlighter language="javascript" >
					//         //     {props.children}
					//         // </SyntaxHighlighter>

					//         <p>{props.children}</p>
					//     );
					// },

					// Blockquotes
					blockquote: ({ node, ...props }) => (
						<blockquote
							className={styles['markdown-blockquote']}
							{...props}
						/>
					),

					// Images
					img: ({ node, ...props }: any) => (
						// <img
						//     className={styles['markdown-image']}
						//     src={node.src}
						//     alt={node.alt}
						//     style={{ maxWidth: "150px" }}
						//     {...props}
						// />
						<ImageWithFallback
							src={node.src}
							alt={node.alt}
							fallbackSrc={defaultImg}
							styles={{ maxWidth: "150px" }}
							{...props}
						/>
					),

					// Table Headers
					th: ({ node, ...props }) => (
						<th
							className={styles['markdown-table-header']}
							style={{ verticalAlign: 'top' }}
							{...props}
						/>
					),

					// Table Cells
					td: ({ node, ...props }) => (
						<td
							className={styles['markdown-table-cell']}
							style={{ verticalAlign: 'top' }}
							{...props}
						/>
					),

					hr: ({ node, ...props }) => (
						<hr style={{ margin: '0.5rem' }} className={styles['markdown-divider']} {...props} />
					),

					// Add other components and styles as needed
				}}
			// remarkPlugins={[remarkGfm]}
			>{content}</ReactMarkdown>
		)
	}

	const downloadBase64File = (base64: string, file_type: string) => {
		const byteCharacters = atob(base64);
		const byteNumbers = new Array(byteCharacters?.length);
		for (let i = 0; i < byteCharacters?.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
		const byteArray = new Uint8Array(byteNumbers);
		// let blob = new Blob([byteArray], { type: 'text/csv' });
		let blob;
		if (localStorage.getItem("clientName") === "InzaloEMS") {
			blob = new Blob([byteArray], { type: file_type });
		} else {
			blob = new Blob([byteArray], { type: 'text/csv' });
		}
		const link = document.createElement('a');
		link.href = URL.createObjectURL(blob);
		if (localStorage.getItem("clientName") === "InzaloEMS") {
			link.download = "Reference_Data.xlsx";
		} else {
			link.download = "Reference_Data.csv";
		}
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const handleDownloadPdf = async (answer: string, file_type: string) => {
		downloadBase64File(answer, file_type)
	}

	// const SendButtonClick = () => {
	//     if (botProduct === "ProductRecommendation") {
	//         handleProductRecommendation();
	//     } else if (botProduct === "ProductSearch") {
	//         handleClickMessage()
	//     }
	// }

	const handleBotHeadSearch = () => {
		const uniqueId = uuidv4();
		setTypePassword("")
		setShowPassword(false)
		setTest("");
		setChatToken("");
		setError(false);
		// dispatch(setBotProduct("ProductSearch"));
		setBotProduct("");
		setLinkIconHover1(LinkIconWhite);
		setLinkIconHover2(LinkIcon);
		dispatch(
			addQuestion({
				id: uniqueId,
				question: "Product Search",
				answer: "",
				isTyping: "Typing",
				is_file: false,
				productType: "product_search",
			})
		);
		handleAnswerResponse(uniqueId, "Product Search", "Sure! How can I assist you with your product search?")
	}
	const handleBotHeadRecommendation = () => {
		const uniqueId = uuidv4();
		setTypePassword("")
		setShowPassword(false)
		// dispatch(setBotProduct("ProductRecommendation"));
		setLinkIconHover2(LinkIconWhite);
		setLinkIconHover1(LinkIcon);
		dispatch(
			addQuestion({
				id: uniqueId,
				question: "Product Recommendation",
				answer: "",
				isTyping: "Typing",
				is_file: false,
				productType: "product_search",
			})
		);
		handleAnswerResponse(uniqueId, "Product Recommendation", "Sounds good! Which products would you like to explore today?")
		// Sure! How can I assist you with your product search?
	}

	const handleVoiceIconClicked = () => {
		// Requirement: when starting a new voice question, stop any currently playing TTS audio
		stopTTSPlayback(true);

		setIsKeyDown(true);
		setMessage('Listening...');
		// dispatch(setQmateValue('Listening...'));
		if (inputbox) {
			inputbox.setAttribute('disabled', true);
		}
		if (sendButton) {
			sendButton.setAttribute('disabled', true);
		}
		handleStartListening();
		inputRef?.current?.focus();
	};

	const [checked, setChecked] = useState<string[]>([]);



	const removeFromCart = (id: string) => {
		// Cookies.remove(`addToCartProducts${localStorage.getItem('username')}`)
		const removedProducts = cartProducts.filter((product: any) => product.variant_id !== id)
		setCartsProduct(removedProducts);
		localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(removedProducts))
		// Cookies.set(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(removedProducts), { expires: 1000 });
	}
	const logoOFCartBot = 'iVBORw0KGgoAAAANSUhEUgAAACEAAAAkCAYAAAAHKVPcAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKuSURBVHgBzViLcdpAEH13iPEwQAYqCO6AdIA7IBWYdEAHgQpIKgiuwKSC0EFwBagDMUYyTgza7AqdJTQS4ERIeTOgQ9zn3d7e29vDs0uTJ5ecjUvfXJe6KAM8OCU+PzYOdVAgNAjjxLseqliu19RDkZCZswUG/Fm+WsSjJcrC05q+GCJFWUMlXwT+wMshZZ+XygfmyBmNLRaqrVaZJAIibAVcGDzwYudjXH+nZqWRMNgSbqxjFYQtKSyQI3h2Lf7qcN+BJlkat6kVjWN6axrhQmCB/CljyFOjJLAlVuZZColQkXtSZu97KIXErronEJSBWSkkKnh1RrvZVPPCScSXAqEQFm8JCwNTZI24K4eEPlyK/asCsZGAyEIV/hxHvFJA0R5uIU+omDq+RIExK3ZIFO0IGSMq/wqR69ikprWG+mT+szIayODGErlYw8yWxWmltoenufTl8PGAnCGD82Pub3FTayv7ZAP3MTjqURhgJrgwUn3Ccah1xaer+Br6Pr77CivLgo0cUKtF1lBZlbxH6muNe1wKCqNaXQW+kakTcuzi2X/koo0LgH2kH/E5A2IVpVjvNd4ryk077nibTvG/4CxLSP5RUeiyCVuSAhjNPwViB99UMZB2WvGyskqetT2T+OXR52S+es62DbI6L5bRhVldWtKtTnVkEqEkJDGqN9Uos62kkVGwio9o8664jr86GkXJwtCUdy/4wOa8ZkkPUgCddVRn/HZ4tiEBIcsOqHhJvu47RSdpjeMkwp0gQazRVgtZT01v3LK0J819zJL9GhxPfnTQwa1EwGeP7rlDm8v9sPN5VjuPteVqHwRbuoIJ5y/d4DAT5nXW9g0TEfk+uC4wjrnmm50TFyl8AzRMuYD5u4RKBmOxmgYDhzc5rnPetZLceZhMSybD5WFavT/egciGFZVKtAAAAABJRU5ErkJggg=='
	const logoOFBot = 'data:image/png;base64,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'
	return (
		<div className={`section-container parent-container`}>
			<div className="section-header" style={{ background: data?.bot_config?.header_colour }}>
				<div className="top-head">
					{
						!_.isEmpty(avtarl)
							? ""
							: ""
						// : <span className="chat-avtar"><img src={`data:image/png;base64,${logoOFCartBot}`} alt="" className="logo-heading preview-logo-heading" /></span>
					}
					<p>
						{
							!_.isEmpty(data?.bot_config?.bot_name)
								? <span>{data?.bot_config?.bot_name}</span>
								: <span>Conversational BI</span>
							// : <span>Welcome to SalesMate</span>
							// : <span>Welcome to ShopMate</span>
						}
						{/* {
							!_.isEmpty(data?.bot_config?.tagline)
								? <span>{data?.bot_config?.tagline}</span>
								: <span>Ask questions, get insights with intelligent visualizations</span>
							// : <span>Intelligent self-service solutions</span>
						} */}
					</p>
				</div>
				<div className="d-flex align-items-center">
					{/* <a title="Cart" className="mr-3 c-pointer" style={{ pointerEvents: cartpageVisible ? 'none' : 'visible', marginRight: '1rem' }} onClick={() => setCartPageVisible(true)}>
                        <i className="pi pi-shopping-cart p-overlay-badge" style={{ fontSize: '1.4rem', color: 'black' }}>
                            {cartProducts.length > 0 &&
                                <Badge value={cartProducts.length} className={cartProducts.length > 9 ? 'my-badge-circle' : "my-badge"}></Badge>
                            }
                        </i>
                    </a> */}
					<a title="Clear chat history">
						<button className="button-section" style={{ pointerEvents: cartpageVisible ? "none" : "auto" }} onClick={() => handleRefresh()}>
							<img src={chatBotRefresh} alt="chatBotRefresh" />
						</button>
					</a>
				</div>
			</div>
			<div className={`section-body-footer-wrap `}>
				{cartpageVisible ?
					<div className="section-body prodct-cart-body">
						<div className={`product-detail-wrap`} style={{ zIndex: "100" }}>
							<div className="product-details">
								<div className="compare-head">
									<h5>Your Cart</h5>
									<span className="compare-head-right">
										<i><img src={CloseIcon} alt="close" onClick={() => {
											setCartPageVisible(false); if (productList.length === 0) {
												setTimeout(() => {
													scrollToBottom();
												}, 100)
											}
										}} /></i>
									</span>
								</div>
								{cartProducts.length === 0 ?
									<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '90%' }}>
										<span>Your cart is empty</span>
										<Button className='outline-active-btn btn-lg mt-2' type="submit" label='Start Shopping' onClick={() => {
											setCartPageVisible(false); setProductList([]); setTimeout(() => {
												scrollToBottom();
											}, 100)
										}}></Button>
									</div>
									:
									<div className="product-cart">
										<DataTable
											value={cartProducts}
											tableStyle={{}}
											emptyMessage=""
											scrollable
											scrollHeight="auto"
										// footer={footer}
										>
											<Column body={(rowData) => (
												<span className="c-pointer" onClick={() => {
													setProductCartList([rowData]); setCartPageVisible(false); setSingleProduct(rowData);
													setCurrentActivePage("detail");
													// customStyleAndBundling(rowData)
												}}>
													<ImageWithFallback
														src={rowData?.variant_image !== null ? rowData?.variant_image : defaultImg}
														alt={rowData?.title}
														fallbackSrc={defaultImg}
														styles={{ width: 60, objectFit: 'cover', borderRadius: '4px' }}
													/>
												</span>
											)} />
											<Column header="Product Name" body={(rowData) => (
												<span className="c-pointer" onClick={() => {
													setProductCartList([rowData]); setCartPageVisible(false); setSingleProduct(rowData);
													setCurrentActivePage("detail")
													// customStyleAndBundling(rowData)
												}} >
													{rowData.title}
												</span>
											)} footer='Grand Total:' ></Column>
											{/* <Column field="price" header="Price" body={(rowData) => (<span>{Number(rowData.price).toFixed(2)}</span>)}
                                                footer={`$${cartProducts.reduce((a: any, b: any) => a + (Number(b.price) || 0), 0).toFixed(2)}`} ></Column> */}
											<Column field="price" header="Price" body={(rowData) => (<span>{formatUSD(rowData?.price)}</span>)}
												footer={`${formatUSD(cartProducts.reduce((a: any, b: any) => a + (Number(b?.price) || 0), 0))}`} ></Column>
											<Column header='Remove' body={(rowData) => (<i onClick={() => removeFromCart(rowData.variant_id)} className="delete-product">
												<img src={DeleteRed} alt="close" />
											</i>)} />
										</DataTable>
									</div>
								}
						</div >
						{/* {cartProducts.length !== 0 &&
                                <div className="d-flex justify-content-center mt-2">
                                    <Button className='outline-active-btn btn-lg' type="submit" label='Proceed to Purchase'></Button>
                                </div>
                            } */}
						</div >
					</div > :
					<div className={`section-body ${productList?.length > 0 || productCartList.length > 0 ? 'overflow-hidden' : 'overflow-auto'}`} >
						{<div className={`output-message-container ${productList?.length > 0 || productCartList.length > 0 ? 'invisible opacity-0' : 'visible opacity-100'}`}>
							{/* {
                                !_.isEmpty(data?.bot_config?.bot_logo)
                                    ? <div><span className="chat-img"><img src={`data:image/png;base64,${data?.bot_config?.bot_logo}`} alt="bot-logo" className="bot-logo" /></span></div>
                                    : <div><span className="chat-img"><img src={logoOFBot} alt="bot-logo" className="bot-logo" /></span></div>
                            } */}
							{
								!_.isEmpty(data?.bot_config?.initial_message)
									? <p className="" style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>{data?.bot_config?.initial_message}</p>
									: <p className="" style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>What would you like to analyze today?</p>
								// : <p className="" style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>Hi, I'm Conversational BI, your AI Assistant!</p>
								// : <p className="" style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>Hi, I'm ShopMate, your AI Assistant!</p>
								// : <p className="" style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>Hey 👋, I'm Ron! I am here to help you with any questions you have.</p>
							}
							{/* <>
                                {(userHandler === undefined || isNewConversation === "old") ?
                                    <p className="" style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>To enhance your personalized experience, we are assigning unique handles to users. Do you already have your unique handle? Please respond with "Yes" or "No".</p>
                                    : <p className="" style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>Welcome back, <b>{userHandler}</b></p>
                                }
                            </> */}
						</div>}
						{messages?.map((obj: any, index: number) => {
							return (
								<React.Fragment key={index}>
									{obj.question && <div className={`input-message-container ${productList?.length > 0 || productCartList.length > 0 ? 'invisible opacity-0' : 'visible opacity-100'}`} >
										<p style={{ background: data?.bot_config?.question_background_colour, fontSize: `${fontSize1}px` }}>{obj.question}</p>
									</div>}
									{obj.isTyping === "Typing"
										? <div className={`output-message-container ${productList?.length > 0 || productCartList.length > 0 ? 'invisible opacity-0' : 'visible opacity-100'}`}>
											{/* {
                                                !_.isEmpty(data?.bot_config?.bot_logo)
                                                    ? <div><span className="chat-img"><img src={`data:image/png;base64,${data?.bot_config?.bot_logo}`} alt="bot-logo" className="bot-logo" /></span></div>
                                                    : <div><span className="chat-img"><img src={logoOFBot} alt="bot-logo" className="bot-logo" /></span></div>
                                            } */}
											<p style={{ background: data?.bot_config?.answer_background_colour, fontSize: `${fontSize1}px` }}>
												<span className="jumping-dots">
													<span className="dot-1"></span>
													<span className="dot-2"></span>
													<span className="dot-3"></span>
												</span>
												<span style={{ marginLeft: '5px' }}>Thinking</span>
											</p>
										</div>
										: handleResponse(obj)
										// : handleResponse(obj.answer)
									}
								</React.Fragment>
							);
						})
						}
						{productDetailPage()}
						{messages?.length === 0 &&
						<div>
							<div className="vc-heading">
								<h2>Visual Comfort<span className="accent"> & Co.</span></h2>
								<p>Welcome back, {isAuthDetails?.email_id} What would you like to analyze today?</p>
							</div>
							<div className="quick-grid">
								{/* <!-- Card 1 --> */}
								<div className="quick-card" data-question="Which are the top 5 products based on total sales?" onClick={() => handleClickMessageSuggestion('Which are the top 5 products based on total sales?')}>
									<div className="quick-icon-pill pill-blue">
										<svg viewBox="0 0 24 24" fill="none">
											<rect x="4" y="10" width="3" height="8" rx="1"
												fill="#4f46e5"></rect>
											<rect x="10.5" y="6" width="3" height="12" rx="1"
												fill="#818cf8"></rect>
											<rect x="17" y="3" width="3" height="15" rx="1"
												fill="#a5b4fc"></rect>
										</svg>
									</div>
									<div className="quick-meta">
										<div className="quick-label">Comparative Analysis   </div>
										<div className="quick-question">Which are the top 5 products based on total sales?</div>
									</div>
								</div>

								{/* <!-- Card 2 --> */}
								<div className="quick-card" data-question="Show me the sales trend for the year 2024" onClick={() => handleClickMessageSuggestion('Show me the sales trend for the year 2024.')}>
									<div className="quick-icon-pill pill-green">
										<svg viewBox="0 0 24 24" fill="none">
											<path d="M4 16L9 11L13 14L19 6"
												stroke="#16a34a" stroke-width="2.2"
												stroke-linecap="round" stroke-linejoin="round"></path>
											<circle cx="19" cy="6" r="2" fill="#bbf7d0"></circle>
										</svg>
									</div>
									<div className="quick-meta">
										<div className="quick-label">Trend Analysis</div>
										<div className="quick-question">Show me the sales trend for the year 2024</div>
									</div>
								</div>

								{/* <!-- Card 3 --> */}
								<div className="quick-card" data-question="Display sales figures by country" onClick={() => handleClickMessageSuggestion('Display sales figures by country')}>
									<div className="quick-icon-pill pill-purple">
										<svg viewBox="0 0 24 24" fill="none">
											<circle cx="9" cy="9" r="3" fill="#a855f7"></circle>
											<circle cx="16" cy="10" r="2.4" fill="#c4b5fd"></circle>
											<path d="M4.5 18c.7-2.2 2.4-3.8 4.5-3.8s3.8 1.6 4.5 3.8"
												stroke="#7c3aed" stroke-width="2" stroke-linecap="round"></path>
											<path d="M13.5 17.8c.6-1.5 1.7-2.6 3.1-2.6 1.4 0 2.6 1 3.1 2.6"
												stroke="#a855f7" stroke-width="1.7" stroke-linecap="round"></path>
										</svg>
									</div>
									<div className="quick-meta">
										<div className="quick-label">Geospatial Analysis</div>
										<div className="quick-question">Display sales figures by country</div>
									</div>
								</div>

								{/* <!-- Card 4 --> */}
								<div className="quick-card" data-question="What is the sales percentage distribution across market regions?" onClick={() => handleClickMessageSuggestion('What is the sales percentage distribution across market regions?')}>
									<div className="quick-icon-pill pill-amber">
										<svg viewBox="0 0 24 24" fill="none">
											<circle cx="12" cy="8" r="4.2" fill="#fed7aa"></circle>
											<path d="M8 19c.7-2 2.2-3.3 4-3.3s3.3 1.3 4 3.3"
												stroke="#f59e0b" stroke-width="2" stroke-linecap="round"></path>
											<text x="12" y="9.2" text-anchor="middle"
												font-size="7" fontFamily="system-ui"
												fill="#b45309">US</text>
										</svg>
									</div>
									<div className="quick-meta">
										<div className="quick-label">Proportional Breakdown</div>
										<div className="quick-question">What is the sales percentage distribution across market regions?</div>
									</div>
								</div>

								{/* <!-- Card 5 --> */}
								<div className="quick-card" data-question="Top performing sales representatives" onClick={() => handleClickMessageSuggestion('Top performing sales representatives')}>
									<div className="quick-icon-pill pill-blue">
										<svg viewBox="0 0 24 24" fill="none">
											<rect x="4" y="10" width="3" height="8" rx="1"
												fill="#4f46e5"></rect>
											<rect x="10.5" y="6" width="3" height="12" rx="1"
												fill="#818cf8"></rect>
											<rect x="17" y="3" width="3" height="15" rx="1"
												fill="#a5b4fc"></rect>
										</svg>
									</div>
									<div className="quick-meta">
										<div className="quick-label">Comparative Analysis</div>
										<div className="quick-question">Top performing sales representatives</div>
									</div>
								</div>

								{/* <!-- Card 6 --> */}
								<div className="quick-card" data-question="What is the sales percentage distribution across market regions?" onClick={() => handleClickMessageSuggestion('What is my sales looking like across different states of the USA for B2B')}>
									<div className="quick-icon-pill pill-purple">
										<svg viewBox="0 0 24 24" fill="none">
											<circle cx="9" cy="9" r="3" fill="#a855f7"></circle>
											<circle cx="16" cy="10" r="2.4" fill="#c4b5fd"></circle>
											<path d="M4.5 18c.7-2.2 2.4-3.8 4.5-3.8s3.8 1.6 4.5 3.8"
												stroke="#7c3aed" stroke-width="2" stroke-linecap="round"></path>
											<path d="M13.5 17.8c.6-1.5 1.7-2.6 3.1-2.6 1.4 0 2.6 1 3.1 2.6"
												stroke="#a855f7" stroke-width="1.7" stroke-linecap="round"></path>
										</svg>
									</div>
									<div className="quick-meta">
										<div className="quick-label">Geospatial Analysis</div>
										<div className="quick-question">What is my sales looking like across different states of the USA for B2B</div>
									</div>
								</div>
							</div>
						</div>
							// <div className="start-suggestion">
							//     <div className='suggested-que'>
							//         <ul className='suggested-que-list'>
							//             <li onClick={() => handleClickMessageSuggestion('What is the sales percentage distribution across market regions?')}><a>What is the sales percentage distribution across market regions?</a></li>
							//             <li onClick={() => handleClickMessageSuggestion('Show me the sales trend for the year 2024.')}><a>Show me the sales trend for the year 2024.</a></li>
							//             <li onClick={() => handleClickMessageSuggestion('Which are the top 5 products based on total sales?')}><a>Which are the top 5 products based on total sales?</a></li>
							//             <li onClick={() => handleClickMessageSuggestion('Display sales figures by country.')}><a>Display sales figures by country.</a></li>
							//             <li onClick={() => handleClickMessageSuggestion('Show sales figures state-wise within the USA.')}><a>Show sales figures state-wise within the USA.</a></li>
							//         </ul>
							//     </div>
							// </div>
						}
						{/* {suggestionList?.length === 0 && showSuggestions &&
                            <div className="start-suggestion-first">
                                <div className='suggested-que'>
                                    <ul className='suggested-que-list'>
                                        <li onClick={() => { dispatch(handleIsUserHandler(true)); handleClickMessageSuggestion('Show me revolving chairs under $150') }}><a>Show me revolving chairs under $150.</a></li>
                                        <li onClick={() => { dispatch(handleIsUserHandler(true)); handleClickMessageSuggestion('Suggest some sofas that mimic the look of leather') }}><a>Suggest some sofas that mimic the look of leather.</a></li>
                                        <li onClick={() => { dispatch(handleIsUserHandler(true)); handleClickMessageSuggestion('Recommend a stylish bed for a modern bedroom') }}><a>Recommend a stylish bed for a modern bedroom.</a></li>
                                        <li onClick={() => { dispatch(handleIsUserHandler(true)); handleClickMessageSuggestion('Show me my orders') }}><a>Show me my orders.</a></li>
                                    </ul>
                                </div>
                            </div>
                        } */}
						<span ref={messagesEndRef}></span>
					</div>
				}
				<div className="section-footer">
					{messages?.length > 0 && !isAnswerCalling && suggestionList?.length > 0 && !cartpageVisible && productList?.length === 0 &&
						<div className="suggestion-nav">
							{showLeft && (
								<button className="nav-btn left" onClick={scrollLeft}>
									<img src={leftIcon} alt="left-icon" />
								</button>
							)}
							<div className="suggestion" ref={scrollRef}>
								{suggestionList.map((list: string) => (
									<div className="list" onClick={() => { dispatch(setSuggestionList([])); handleClickMessageSuggestion(list) }}>{list}</div>
								))}
							</div>
							{showRight && (
								<button className="nav-btn right" onClick={scrollRight}>
									<img src={rightIcon} alt="right-icon" />
								</button>
							)}
						</div>
					}
					<div className={`input-section ${(typePassword) ? "input-password" : ""}`}>
						{/* <i className="pi pi-plus-circle"></i> */}
						<input type={!showPassword && typePassword && productList?.length === 0 ? "password" : "text"} autoComplete={(!showPassword && !typePassword) ? 'off' : 'new-password'} onChange={(e) => handleChange(e)}
							onKeyDown={(e) => {
								if (
									e.key === "Enter" &&
									message !== "Listening..." &&
									!isAnswerCalling &&
									!isKeyDown &&
									message.trim() !== "" &&
									ishandleModeDetails !== 'voice'
								) {
									// SendButtonClick();
									handleClickMessage();
								}
							}}
							ref={inputRef}
							readOnly={message === "Listening..."}
							value={message}
							placeholder={
								ishandleModeDetails === 'voice'
									? 'Voice mode only'
									: 'Ask me anything'
							}
							disabled={(ishandleModeDetails === 'voice' || message === "Listening..." || isKeyDown) ? true : false}
						// disabled={ botProduct === "" ? true : false}
						/>
						{
							typePassword && productList?.length === 0 &&
							<span className={`password-toggle3 me-5`} onClick={() => setShowPassword(!showPassword)}>
								{!showPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
									<img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
								}
							</span>
						}
						{/* {(ishandleModeDetails && (ishandleModeDetails === 'text' || ishandleModeDetails === 'hybrid')) && ( */}
						<button type="button" disabled={message.trim() === "" ? true : false} style={{ pointerEvents: (message === "" || message === "Listening..." || message.trim() === "" || isAnswerCalling || isKeyDown) ? "none" : "visible" }} onClick={handleClickMessage}>
							<i className={`${message !== "Listening..." && message.trim() !== "" ? 'active-className' : 'inActive-className'}`}
							>
								<img src={searchSend} alt='send-btn' />
							</i>
						</button>
						{/* )} */}
						{(!typePassword) && (ishandleModeDetails && (ishandleModeDetails === 'voice' || ishandleModeDetails === 'hybrid')) && (
							<button disabled={isTTSLoading || message === "Listening..." || isKeyDown} style={{ pointerEvents: (isTTSLoading || message === "Listening..." || isKeyDown) ? "none" : "visible" }}>
								<i className={`last-icon ${message !== "" ? 'active-className' : 'inActive-className'}`}><img src={message === "Listening..." ? searchMicActive : searchMic} onClick={handleVoiceIconClicked} alt='mic-btn' title='Search via Voice' /></i>
							</button>
						)}
					</div>
				</div>
			</div >
			{
				botLoader && (
					<div className="clip-loader-bot">
						<div className="loader-spinner"></div>
					</div>
				)
			}
		</div >
	)
}

export default Chatbot;